import React, { Component, createRef } from 'react';
import moment from 'moment';
import 'moment/locale/es';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import Headers from './Header';
import NavigationBar from './Navigation';
import Loader from '../common/Loader';
import SessionType from '../common/SessionType';
import AddRemoveStudent from '../common/AddRemoveStudent';
import FlaggedSessionTable from '../common/FlaggedSessionTable';
import RecordingModal from '../common/RecordingModal';
import CheckMediaAccess from '../common/CheckMediaAccess';
import store from '../../../sessionStorage';
import { myLog, validateEmail } from '../../../utils/Utility';
import { PATH } from '../../../utils/Constants';
import { getCallStatus } from '../../action/VideoCallAction';
import { showNotification } from '../../action/NotificationAction';
import {
    getStudentInfoDate,
    getAvailableStudentList,
    updateClassRoomSession,
    updateVisitThirdParty,
    fetchStudentAttendance,
    getSessionSummaryChatWithPagination,
    fetchBroadcastStudentDetails,
    getBudSummary,
} from '../../action/educator/AppointmentAction';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import StudentParticipation from '../common/StudentParticipation';
import NotesCompleteConfirmation from '../common/NotesCompleteConfirmation';
import { saveSoap, saveSoap_V2 } from '../../action/educator/MyPatientInfoAction';
// import profileImg from "../../../utils/images/profileImg.png";
import {
    attachmentSave,
    getUserById,
    getVisitInformation,
    removeImageFromSession,
} from '../../action/Admin/CommonAction';
import {
    BroadCastSession,
    ClassroomSession,
    ConferenceCall,
    Good,
    InPerson,
    Scheduled,
    Tutor,
    Unknown,
} from '../../../utils/common/NamingTerms';
import CheckNetworkConnection from '../common/CheckNetworkConnection';
import Client from '../../../utils/ClientVOIM';
import AppConfig, { fetchDomainConfiguration } from '../../../utils/common/DomainConfiguration';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';
import AddExternalEmail from '../common/AddExternalEmail';
import {
    pruneWhiteboardSessionsExcept,
    setActiveWhiteboardSession,
} from '../../../utils/WhiteboardSessionStorage';

moment.locale(AppConfig.appLanguage || 'en');

const { detect } = require('detect-browser');
const browser = detect();
const MEETING_SUMMARY_EVENT = 'meeting-summary-received';
const MAX_EXTERNAL_EMAILS = 10;

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t, language }) => (
                        <WrappedComponent {...this.props} t={t} language={language} />
                    )}
                </LanguageContext.Consumer>
            );
        }
    };
};

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class WaitingRoom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false,
            visitInfo: {},
            patientEmail: '',
            patientName: '',
            sessionStatus: '',
            sessionStudents: [],
            savedSessionStudents: [],
            editSessionStudents: [],
            isLoading: false,
            isTabName: 'notes',
            chatLoading: false,
            chatMessage: [],
            showAll: false,
            addRemoveStudentModal: false,
            addExternalEmailModal: false,
            studentParticipationModal: false,
            participationType: 'team',
            sessionNotesModal: false,
            sessionNotesEditorMode: 'raw',
            notesCompleteModal: false,
            sessionNotesTitle: '',
            uploadedImages: [],
            uploadComplaintImages: [],
            subjective: '',
            objective: '',
            plan: '',
            backupSubjective: '',
            backupObjective: '',
            backupPlan: '',
            materialImages: [],
            title: '',
            isVisitNoteComplete: 0,
            materialUploadedImages: [],
            visitType: '',
            dateTime: [],
            summary: false,
            availableStudentList: [],
            savedAvailableStudentList: [],
            studentAttendanceDetails: [],
            sessionId: '',
            isStudentListLoading: false,
            btnLoading: false,
            totalPages: 0,
            currentPage: 0,
            isStudentLoading: false,
            addComplaintImage: false,
            isImageUploaded: false,
            flagLoading: false,
            flaggedInformation: {},
            isSaveStudent: false,
            isSaveExternalEmail: false,
            searchValue: '',
            isVideoOpen: false,
            videos: [],
            currentChatPage: 1,
            chatPerPage: 10,
            chatLastPage: 1,
            transcriptText: '',
            externalEmails: [],
            savedExternalEmails: [],
            currentExternalEmail: '',
            refreshingNotes: false,
            copiedExternalInviteLink: false,
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.chatContainerRef = createRef();
        this.networkChecker = new CheckNetworkConnection();
        this.mediaChecker = new CheckMediaAccess();
        this.networkChecker.browser = browser.name;
    }

    //componentDidMount
    componentDidMount() {
        const initialVisitId = this.props.match?.params?.visitId;
        if (initialVisitId) {
            setActiveWhiteboardSession(initialVisitId);
            pruneWhiteboardSessionsExcept(initialVisitId);
        }
        this.setIntervalForGetSessionDetails();
        window.addEventListener(MEETING_SUMMARY_EVENT, this.handleMeetingSummaryReceived);

        const url = this.props.visitDetails?.transcriptionFileURL;
        if (url) {
            fetch(url)
                .then((res) => res.text())
                .then((text) => this.setState({ transcriptText: text }))
                .catch((err) => {
                    console.error('Error loading transcript:', err);
                    this.setState({ transcriptText: 'Failed to load transcript' });
                });
        }
    }

    //componentDidUpdate
    componentDidUpdate(prevProps) {
        const prevVisitId = prevProps.match?.params?.visitId;
        const currentVisitId = this.props.match?.params?.visitId;
        if (currentVisitId && prevVisitId !== currentVisitId) {
            setActiveWhiteboardSession(currentVisitId);
            pruneWhiteboardSessionsExcept(currentVisitId);
        }
        // Fetch transcript only when transcriptionFileURL becomes available
        const prevURL = prevProps.visitDetails?.transcriptionFileURL;
        const currentURL = this.props.visitDetails?.transcriptionFileURL;
        if (currentURL && currentURL !== prevURL) {
            fetch(currentURL)
                .then((res) => res.text())
                .then((text) => this.setState({ transcriptText: text }))
                .catch((err) => {
                    console.error('Error loading transcript:', err);
                    this.setState({ transcriptText: 'Failed to load transcript' });
                });
        }
        // Clear transcript when URL becomes null
        if (!currentURL && prevURL) {
            this.setState({ transcriptText: '' });
        }
        // Existing deactivateUserScreen logic
        if (this.props.deactivateUserScreen !== prevProps.deactivateUserScreen) {
            clearInterval(this.timer);
        }
    }

    getUserById(callBack) {
        return function (dispatch) {
            const userId = store.get('bloomIfAI_id');
            const domainConfig = fetchDomainConfiguration();
            const API_BASE_URL = domainConfig.bloomIfAI_url;
            const bloomIfAI_access_token = sessionStorage.getItem('bloomIfAI_access_token');
            const headers = {
                Authorization: `Bearer ${bloomIfAI_access_token}`,
                'Content-Type': 'application/json',
            };

            Client.get(`${API_BASE_URL}/api/v4/user/${userId}`, null, true, headers)
                .then((response) => {
                    callBack(response);
                })
                .catch((error) => {
                    callBack(false);
                });
        };
    }

    //componentWillMount
    componentWillMount() {
        const { match } = this.props;
        if (match.path.includes('/summary')) {
            this.setState({ summary: true });
            this.getDateTime(match.params.studentId);
        } else {
            this.setState({ summary: false });
            this.invokeVisitInfo(match.params.visitId, true);
        }
    }

    //componentWillUnmount
    componentWillUnmount() {
        clearInterval(this.timer);
        clearTimeout(this.copyExternalInviteLinkTimer);
        window.removeEventListener(MEETING_SUMMARY_EVENT, this.handleMeetingSummaryReceived);
    }

    handleMeetingSummaryReceived = (event) => {
        const payload = event?.detail || {};
        const currentVisitId = this.props.match?.params?.visitId;

        if (this.state.summary || !currentVisitId) {
            return;
        }

        const isExactVisitMatch =
            payload.visitId && String(payload.visitId) === String(currentVisitId);
        if (isExactVisitMatch || !payload.visitId || this.state.sessionStatus === 'Note Pending') {
            this.invokeVisitInfo(currentVisitId, true);
        }
    };

    isMeetingSummaryPending = () => {
        const objectiveNotes = this.props.visitDetails?.soapNote?.objective;
        const hasGeneratedSummary =
            typeof objectiveNotes === 'string' && objectiveNotes.trim().length > 0;

        return this.state.sessionStatus === 'Note Pending' && !hasGeneratedSummary;
    };

    //setIntervalForGetSessionDetails
    setIntervalForGetSessionDetails = () => {
        this.timer = setInterval(() => {
            const { match } = this.props;
            if (!this.state.summary && !this.state.sessionId) {
                this.invokeVisitInfo(match.params.visitId, true);
            } else {
                // this.invokeVisitInfo(this.state.sessionId, true);
            }
        }, 30000);
    };

    //isLoading
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    // Fetch Session Summary
    invokeVisitInfo(visitId, isLoading) {
        const { match } = this.props;
        if (isLoading) {
            this.isLoading();
        }
        this.props.getVisitInformation(visitId, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                let optionDetails = [];
                if (response.response.sessionUsers && response.response.sessionUsers.length) {
                    response.response.sessionUsers
                        .filter((element) => element.thirdParty === false)
                        .forEach((element) => {
                            let obj = {
                                label: element.name,
                                value: element.id,
                                owner: element.stuRollNo,
                            };
                            optionDetails.push(obj);
                        });
                }

                const externalEmailDetails =
                    response.response.sessionUsers && response.response.sessionUsers.length
                        ? response.response.sessionUsers
                              .filter((element) => element.thirdParty === true && element.email)
                              .map((element) => element.email.toLowerCase())
                        : [];

                this.setState(
                    {
                        visitInfo: response.response,
                        sessionStatus: response.response.sessionStatus,
                        patientEmail: response.response.tutee?.email,
                        patientName: response.response.tutee?.name,
                        sessionStudents: response.response.sessionUsers,
                        savedSessionStudents: optionDetails,
                        editSessionStudents: optionDetails,
                        uploadedImages: response.response.soapNote?.visitComplaintImages,
                        subjective: this.normalizeNoteText(
                            response.response.soapNote?.subjective
                        ),
                        objective: this.normalizeNoteText(response.response.soapNote?.objective),
                        plan: this.normalizeNoteText(response.response.soapNote?.plan),
                        materialImages: response.response.soapNote?.materialImages,
                        isVisitNoteComplete: response.response.soapNote?.visitNoteCompletedStatus,
                        visitType: response.response.visitType,
                        flaggedInformation: response.response?.flaggedSession,
                        externalEmails: externalEmailDetails,
                        savedExternalEmails: externalEmailDetails,
                        currentExternalEmail: '',
                        isTabName:
                            !match.path.includes('/summary') &&
                            response.response?.flaggedSession?.flaggedCategory
                                ? 'flagged'
                                : 'notes',
                    },
                    () => {
                        this.isLoading();
                        if (response.response.visitType !== ClassroomSession) {
                            this.setState({
                                patientUserId: response?.response?.tutee?.userId
                                    ? response.response?.tutee?.userId
                                    : 0,
                            });
                        }
                        if (
                            this.state.sessionStatus === 'Missed' ||
                            this.state.sessionStatus === 'Cancelled' ||
                            this.state.sessionStatus === 'Note Pending' ||
                            this.state.sessionStatus === 'Completed'
                        ) {
                            clearInterval(this.timer);
                        }
                    }
                );
            } else if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                myLog('error');
                this.isLoading();
            }
        });
    }

    //getDateTime
    getDateTime(studentId) {
        this.isLoading();
        this.props.getStudentInfoDate(studentId, (res) => {
            if (res.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({ dateTime: res.response.reverse() }, () => {
                    if (res.response.length > 0) {
                        const lastDate = res.response[0].id;
                        this.setState({ sessionId: lastDate }, () => {
                            this.invokeVisitInfo(this.state.sessionId, false);
                        });
                    }
                });
            }
        });
    }

    // Get Student Details
    getAvailableStudentList(sessionId) {
        this.setState({ isStudentLoading: true });
        let params = {
            sessionId: sessionId,
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getAvailableStudentList(params, (result) => {
            if (result) {
                this.setState({
                    isStudentLoading: false,
                });
                let studentDetails = [];
                if (result.response.data && result.response.data.length) {
                    result.response.data.forEach((element) => {
                        let name = element.name;
                        let obj = {
                            label: name,
                            value: element.id,
                            owner: element.owner,
                        };
                        studentDetails.push(obj);
                    });
                }
                this.setState({
                    savedAvailableStudentList: studentDetails,
                    availableStudentList: studentDetails,
                });
            }
        });
    }

    // Fetch Student Attendance Details
    fetchStudentAttendance(search, currentPage, itemsPerPage) {
        this.setState({ isStudentListLoading: true });
        let values = {
            search: search,
            pageNumber: currentPage + 1,
            itemsPerPage,
            sessionId: this.props.match.params.visitId,
            isBroadcastSession:
                this.state.visitInfo?.sessionType === BroadCastSession ? true : false,
        };
        this.props.fetchStudentAttendance(values, (result) => {
            this.setState({ isStudentListLoading: false });
            if (result) {
                this.setState({
                    studentAttendanceDetails: result.response.data,
                    totalPages: result.response.totalPages,
                });
            } else {
                this.setState({ totalPages: 0 });
            }
        });
    }

    //fetchBroadcastStudentDetails
    fetchBroadcastStudentDetails(currentPage, itemsPerPage) {
        this.setState({ isStudentListLoading: true });
        let values = {
            pageNumber: currentPage + 1,
            itemsPerPage,
        };
        let sessionId = this.props.match.params.visitId;
        this.props.fetchBroadcastStudentDetails(sessionId, values, (result) => {
            this.setState({ isStudentListLoading: false });
            if (result) {
                let broabcastStudentDetails = [];
                const levels = Object.values(result.response);
                levels.forEach((level) => {
                    if (level?.students && level?.students?.length) {
                        let studentDetails = level?.students;
                        studentDetails.forEach((element) => {
                            let obj = {};
                            obj.levelName = level?.levelName;
                            obj.name = element.studentName;
                            broabcastStudentDetails.push(obj);
                        });
                    }
                });
                this.setState({
                    studentAttendanceDetails: broabcastStudentDetails,
                    totalPages: result.response.totalPages,
                });
            } else {
                this.setState({ totalPages: 0 });
            }
        });
    }

    //handleSearchUser
    handleSearchUser = (event) => {
        const searchValue = event.target.value;
        this.setState({ searchValue });
        clearTimeout(this.state.timeout);
        const timeout = setTimeout(() => {
            this.fetchStudentAttendance(this.state.searchValue, 0, 1000);
        }, 1000); // 1Sec delay before triggering the search
        this.setState({ timeout });
    };

    // Handle  Page change
    handlePageChange(event) {
        this.setState(
            {
                currentPage: Number(event.selected),
            },
            this.fetchStudentAttendance(this.state.searchValue, Number(event.selected), 1000)
        );
    }

    normalizeNoteText = (noteText) => {
        if (typeof noteText !== 'string') return noteText || '';
        return noteText.replace(/\\n/g, '\n');
    };

    // Add Or Remove Students From Session Summary
    saveStudents() {
        if (this.state.editSessionStudents && !this.state.editSessionStudents.length) {
            this.props.showNotification(
                RESPONSE_CONSTANT.STUDENT_MANDATORY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        this.setState({ isSaveStudent: true });
        const addedStudents = this.state.editSessionStudents.filter(
            (obj2) =>
                !this.state.savedSessionStudents.some((obj1) => obj1['value'] === obj2['value'])
        );
        const deletedStudents = this.state.savedSessionStudents.filter(
            (obj2) =>
                !this.state.editSessionStudents.some((obj1) => obj1['value'] === obj2['value'])
        );
        let addedStudentId = [];
        let addedOwnerId = [];
        if (addedStudents && addedStudents.length) {
            addedStudents.forEach((element) => {
                if (element.owner) {
                    addedOwnerId.push(element.value);
                } else {
                    addedStudentId.push(element.value);
                }
            });
        }
        let deletedStudentId = [];
        let deletedOwnerId = [];
        if (deletedStudents && deletedStudents.length) {
            deletedStudents.forEach((element) => {
                if (element.owner !== null) {
                    deletedStudentId.push(element.value);
                } else {
                    deletedOwnerId.push(element.value);
                }
            });
        }
        let classRoomDataParams = {
            visitId: this.props.match.params.visitId,
            addedStudentIds: addedStudentId,
            deletedStudentIds: deletedStudentId,
            addedOwnerIds: addedOwnerId,
            deletedOwnerIds: deletedOwnerId,
        };
        this.props.createClassRoomSession(classRoomDataParams, (res) => {
            this.setState({ addRemoveStudentModal: false, isSaveStudent: false });
            this.setIntervalForGetSessionDetails();
            if (res.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(res.message, 'success');
                this.invokeVisitInfo(this.props.match.params.visitId, true);
            } else {
                this.props.showNotification(res.message, 'error');
            }
        });
    }

    handleExternalEmailInputChange = (event) => {
        this.setState({ currentExternalEmail: event.target.value });
    };

    handleAddExternalEmail = () => {
        const { externalEmails, currentExternalEmail } = this.state;
        const email = (currentExternalEmail || '').trim();

        if (!email) {
            this.props.showNotification(
                this.props.t('enterEmailAddressError'),
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }

        if (externalEmails.length >= MAX_EXTERNAL_EMAILS) {
            this.props.showNotification(
                this.props.t('maxEmailAddressesError').replace('{count}', MAX_EXTERNAL_EMAILS),
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }

        if (!validateEmail(email)) {
            this.props.showNotification(
                this.props.t('validEmailAddressError'),
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }

        const normalizedEmail = email.toLowerCase();
        if (externalEmails.some((item) => item.toLowerCase() === normalizedEmail)) {
            this.props.showNotification(
                this.props.t('duplicateEmailAddressError'),
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }

        this.setState((prevState) => ({
            externalEmails: [...prevState.externalEmails, normalizedEmail],
            currentExternalEmail: '',
        }));
    };

    handleRemoveExternalEmail = (index) => {
        this.setState((prevState) => ({
            externalEmails: prevState.externalEmails.filter((email, i) => i !== index),
        }));
    };

    saveExternalEmails = () => {
        const { externalEmails, savedExternalEmails } = this.state;

        if (!externalEmails.length) {
            this.props.showNotification(
                this.props.t('atLeastOneEmailAddressError'),
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }

        const addExternalEmails = externalEmails.filter(
            (email) => !savedExternalEmails.some((savedEmail) => savedEmail === email)
        );
        const removeExternalEmails = savedExternalEmails.filter(
            (email) => !externalEmails.some((currentEmail) => currentEmail === email)
        );

        const values = {
            addExternalEmails,
            removeExternalEmails,
            visitId: this.props.match.params.visitId,
        };

        this.setState({ isSaveExternalEmail: true });
        this.props.updateVisitThirdParty(values, (res) => {
            this.setState({ isSaveExternalEmail: false });
            if (res && res.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(res.message, 'success');
                this.setState({ addExternalEmailModal: false, currentExternalEmail: '' });
                this.setIntervalForGetSessionDetails();
                this.invokeVisitInfo(this.props.match.params.visitId, true);
            } else {
                this.props.showNotification(
                    (res && res.message) || this.props.t('failedToUpdateExternalMembers'),
                    'error'
                );
            }
        });
    };

    showExternalEmailValidationError = (message) => {
        this.props.showNotification(message, RESPONSE_CONSTANT.WARNING);
    };

    //handleScroll
    handleScroll = () => {
        const chatContainer = this.chatContainerRef.current;
        const { scrollTop, scrollHeight, clientHeight } = chatContainer;
        if (scrollHeight <= Math.round(scrollTop) + clientHeight) {
            if (this.state.chatLastPage > this.state.currentChatPage) {
                this.getSessionSummaryChatWithPagination(
                    this.props.match.params.visitId,
                    this.state.currentChatPage,
                    this.state.chatPerPage
                );
                this.setState({
                    currentChatPage: this.state.currentChatPage + 1,
                });
            }
        }
    };

    // Fetch Session Summary Chat
    getSessionSummaryChatWithPagination(visitId, pageNumber, chatPerPage) {
        const values = {
            sort: 'asc',
            pageNumber: pageNumber + 1,
            itemsPerPage: chatPerPage,
            isSysNotificationReqd: true,
        };
        this.props.getSessionSummaryChatWithPagination(visitId, values, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    chatMessage: [...this.state.chatMessage, ...response.response.data.messages],
                    chatLoading: false,
                    chatLastPage: response.response.totalPages,
                });
            } else if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                myLog('error');
            }
        });
    }

    //saveSessionNotes
    saveSessionNotes = (isVisitNoteComplete, setLoading = true, titleOverride = null) => {
        if (setLoading) {
            this.setState({ btnLoading: true });
        }
        const { subjective, objective, plan, materialUploadedImages, title } = this.state;
        const endpointTitle = typeof titleOverride === 'string' ? titleOverride : title;
        this.props.saveSoap_V2(
            subjective,
            objective,
            plan,
            materialUploadedImages,
            this.state.visitInfo.handouts,
            this.props.match.params.visitId,
            isVisitNoteComplete,
            0,
            endpointTitle,
            (result) => {
                this.setState({
                    btnLoading: false,
                    notesCompleteModal: false,
                    isImageUploaded: false,
                });
                if (result) {
                    if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.setState({
                            sessionNotesModal: false,
                            materialUploadedImages: [],
                            backupSubjective: this.state.subjective,
                            backupObjective: this.state.objective,
                            backupPlan: this.state.plan,
                        });
                        this.setIntervalForGetSessionDetails();
                        this.invokeVisitInfo(this.props.match.params.visitId, true);
                        this.props.showNotification(result.message, 'success');
                    } else {
                        this.props.showNotification(result.message, 'error');
                    }
                } else {
                    this.props.showNotification(this.props.t('soapNotSaved'), 'error');
                    return;
                }
            }
        );
        this.setState({ enableSave: false });
    };

    /**
     * Handle video call
     */

    handleVideoCall(type) {
        const sessionVisitId = this.state.summary
            ? this.state.sessionId
            : this.props.match.params.visitId;
        setActiveWhiteboardSession(sessionVisitId);
        pruneWhiteboardSessionsExcept(sessionVisitId);
        sessionStorage.setItem('VISIT_TYPE', type);
        sessionStorage.setItem('SESSION_TYPE', this.state.visitInfo.sessionType || '');
        this.props.getCallStatus(this.props.match.params.visitId, (response) => {});
        if (type === 'class_room' || type === 'conference_call') {
            this.props.history.push(
                `${PATH.IM_PHYSICIAN.VIDEO_CALL}/${sessionVisitId}/${Tutor}/${store.get('userSession').id}/classroom`
            );
        } else if (type === 'broadcast') {
            this.props.history.push(
                `${PATH.IM_PHYSICIAN.VIDEO_CALL}/${sessionVisitId}/${Tutor}/${store.get('userSession').id}/broadcast`
            );
        } else {
            const userId = store.get('userSession').id;
            const videoCallPath =
                this.state.visitInfo.sessionType === InPerson
                    ? `${PATH.IM_PHYSICIAN.VIDEO_CALL}/${sessionVisitId}/${Tutor}/${userId}`
                    : `${PATH.IM_PHYSICIAN.VIDEO_CALL}/${sessionVisitId}/${Tutor}/${userId}/${this.state.patientUserId}`;

            this.props.history.push(videoCallPath);
        }
    }

    //preCallTest
    preCallTest = async () => {
        try {
            this.setState({ checkPermissionStatus: true });
            sessionStorage.setItem('SESSION_TYPE', this.state.visitInfo.sessionType || '');
            await this.mediaChecker.finalCheckingPermission();
            if (
                this.mediaChecker.state.cameraGranted &&
                this.mediaChecker.state.microphoneGranted &&
                !this.mediaChecker.state.systemCameraBlocked &&
                !this.mediaChecker.state.systemMicrophoneBlocked
            ) {
                const networkGood =
                    this.networkChecker.browser === 'firefox' ||
                    this.networkChecker.browser === 'safari'
                        ? await this.networkChecker.checkfirefoxNetworkSignal()
                        : await this.networkChecker.checkNetworkSignal();

                if (
                    networkGood &&
                    (this.networkChecker.state.networkQuality === Good ||
                        this.networkChecker.state.networkQuality === Unknown)
                ) {
                    console.log(
                        'Network and media checks passed, joining session with quality:',
                        this.networkChecker.state.networkQuality
                    );
                    this.handleVideoCall(
                        this.state.visitType === ClassroomSession
                            ? 'class_room'
                            : this.state.visitType === BroadCastSession
                              ? 'broadcast'
                              : this.state.visitType === ConferenceCall
                                ? 'conference_call'
                                : 'one_to_one'
                    );
                } else {
                    console.log(
                        'Session join blocked. Network quality:',
                        this.networkChecker.state.networkQuality,
                        'Network good:',
                        networkGood
                    );
                }
            } else {
                this.setState({ checkPermissionStatus: false });
            }
        } catch (error) {
            console.log('error: ', error);
        }
    };

    navigateToSessionEdit = () => {
        const { visitInfo } = this.state;

        if (!visitInfo?.id) {
            return;
        }

        const startDateTime =
            visitInfo?.onDemand?.startTime ||
            visitInfo?.appointment?.startTime ||
            visitInfo?.sessionStartDate ||
            '';
        const endDateTime =
            visitInfo?.onDemand?.endTime ||
            visitInfo?.appointment?.endTime ||
            visitInfo?.sessionEndDate ||
            '';

        const startMoment = startDateTime ? moment(startDateTime) : null;
        const endMoment = endDateTime ? moment(endDateTime) : null;

        const sessionDate =
            startMoment && startMoment.isValid()
                ? startMoment.format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD');

        this.props.history.push({
            pathname: `${PATH.IM_PHYSICIAN.APPOINTMENT}/${this.props.match.params.userId}/update`,
            state: {
                isReschedule: true,
                rescheduleSession: {
                    visitId: visitInfo.id,
                    visitType: visitInfo.visitType || null,
                    sessionType: visitInfo.sessionType || '',
                    sessionDate,
                    sessionStartTime:
                        startMoment && startMoment.isValid()
                            ? startMoment.format('YYYY-MM-DD HH:mm:ss')
                            : startDateTime,
                    sessionEndTime:
                        endMoment && endMoment.isValid()
                            ? endMoment.format('YYYY-MM-DD HH:mm:ss')
                            : endDateTime,
                    subjectId: visitInfo.expertiseCategoryId || null,
                    subjectLabel: visitInfo.expertiseCategory || '',
                    subCategoryId: visitInfo.expertiseId || null,
                    subCategoryLabel: visitInfo.expertise || '',
                    studentId: visitInfo.tutee?.id || visitInfo.studentId || null,
                    studentName: visitInfo.tutee?.name || visitInfo.studentName || '',
                    sessionUsers: Array.isArray(visitInfo.sessionUsers)
                        ? visitInfo.sessionUsers
                        : [],
                    externalUserEmails: Array.isArray(visitInfo.sessionUsers)
                        ? visitInfo.sessionUsers
                              .filter((user) => user?.thirdParty === true && user?.email)
                              .map((user) => String(user.email).toLowerCase())
                        : [],
                    topic: visitInfo.topic || visitInfo.summary || '',
                    comments: visitInfo.comments || '',
                    referenceFiles: Array.isArray(visitInfo.referenceFiles)
                        ? visitInfo.referenceFiles
                        : [],
                },
            },
        });
    };

    // Render Appointment Status Button
    renderAppointmentStatusButton(status) {
        const visitInfo = this.state.visitInfo || {};
        const normalizedStatus = typeof status === 'string' ? status.trim() : status;
        const statusesWithoutEdit = ['Cancelled', 'Owner Missed', 'Team Member Missed'];
        const hasStartedSession =
            visitInfo.hasStartedSession === true ||
            String(visitInfo.hasStartedSession || '')
                .trim()
                .toLowerCase() === 'true';
        const isOneToOneSession =
            visitInfo.visitType !== ClassroomSession &&
            visitInfo.visitType !== BroadCastSession &&
            visitInfo.visitType !== ConferenceCall;
        const canEditScheduledSession =
            !this.state.summary &&
            !!visitInfo.id &&
            !!this.props.match?.params?.userId &&
            (isOneToOneSession ? !hasStartedSession : !!visitInfo.isAllowToEdit) &&
            !statusesWithoutEdit.includes(normalizedStatus);

        const renderEditButton = () =>
            canEditScheduledSession && (
                <button
                    type="button"
                    className="inline-flex items-center justify-center w-8 h-8 border rounded-lg text-emerald border-emerald"
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        this.navigateToSessionEdit();
                    }}
                    title={this.props.t('edit')}
                >
                    <i className="fas fa-pen"></i>
                </button>
            );

        if (/Missed$/i.test(status)) {
            const missedText =
                status === 'Team Member Missed'
                    ? this.props.t('teamMemberMissed')
                    : status === 'Owner Missed'
                      ? this.props.t('ownerMissed')
                      : status === 'Doctor Missed'
                        ? this.props.t('doctorMissed')
                        : status;
            return (
                <div className="inline-flex items-center gap-2">
                    {renderEditButton()}
                    <button
                        type="button"
                        className="border rounded-lg font-medium text-base px-4 py-1.5 text-red border-red cursor-auto"
                    >
                        {missedText}
                    </button>
                </div>
            );
        } else if (status === 'Booked' || status === Scheduled) {
            return (
                <div className="inline-flex items-center gap-2">
                    {renderEditButton()}
                    <button
                        type="button"
                        className="inline-flex items-center border rounded-lg font-medium text-base px-4 py-1.5 text-emerald border-emerald cursor-auto"
                    >
                        {this.props.t('scheduled')}
                    </button>
                </div>
            );
        } else if (status === 'In Waiting Room') {
            return (
                <div className="inline-flex items-center gap-2">
                    {renderEditButton()}
                    <button
                        type="button"
                        className="border rounded-lg font-medium text-base px-4 py-1.5 text-gray border-gray cursor-auto"
                    >
                        {this.props.t('inWaitingRoom')}
                    </button>
                </div>
            );
        } else if (status === 'Enter Virtual Class Room') {
            return (
                <div className="inline-flex items-center gap-2">
                    {renderEditButton()}
                    <button
                        type="button"
                        className="border rounded-lg font-medium text-base px-4 py-1.5 text-emerald border-emerald"
                        onClick={this.preCallTest}
                    >
                        {this.props.t('enterSession')}
                    </button>
                </div>
            );
        } else if (status === 'Visit In Call') {
            return (
                <div className="inline-flex items-center gap-2">
                    {renderEditButton()}
                    <button
                        type="button"
                        className="border rounded-lg font-medium text-base px-4 py-1.5 text-emerald border-emerald"
                        onClick={this.preCallTest}
                    >
                        {this.props.t('resumeYourSession')}
                    </button>
                </div>
            );
        } else if (status === 'Completed') {
            return (
                <div className="inline-flex items-center gap-2">
                    {renderEditButton()}
                    <button
                        type="button"
                        className="border rounded-lg font-medium text-base px-4 py-1.5 text-success border-success cursor-auto"
                        style={{
                            pointerEvents: 'none',
                        }}
                    >
                        {this.props.t('completed')}
                    </button>
                </div>
            );
        } else if (status === 'Pending') {
            return (
                <div className="inline-flex items-center gap-2">
                    {renderEditButton()}
                    <button
                        type="button"
                        className="border rounded-lg font-medium text-base px-4 py-1.5 text-warning border-warning cursor-auto"
                    >
                        {this.props.t('pending')}
                    </button>
                </div>
            );
        } else if (status === 'Note Pending') {
            return (
                <div className="inline-flex items-center gap-2">
                    {renderEditButton()}
                    <button
                        type="button"
                        className="rounded-lg font-medium text-base px-4 py-1.5 text-white cursor-auto"
                        style={{ backgroundColor: '#2987D3' }}
                    >
                        {this.props.t('notesPending')}
                    </button>
                </div>
            );
        } else if (status === 'Cancelled') {
            return (
                <div className="inline-flex items-center gap-2">
                    {renderEditButton()}
                    <button
                        type="button"
                        className="border rounded-lg font-medium text-base px-4 py-1.5 text-red border-red cursor-auto"
                    >
                        {this.props.t('cancelled')}
                    </button>
                </div>
            );
        } else {
            return <div />;
        }
    }

    // Render students list with more option
    isThirdPartyUser = (user) => {
        const thirdParty = user?.thirdParty;
        return thirdParty === true || thirdParty === 1 || thirdParty === 'true' || thirdParty === '1';
    };

    renderStudentsWithMore(users, isThirdParty = false) {
        let studentNames = [];

        const isCompletedOrNotePending =
            this.state.sessionStatus === 'Completed' || this.state.sessionStatus === 'Note Pending';
        // const isConferenceSession = this.state.visitInfo.sessionType === ConferenceCall;

        if (users && users.length) {
            studentNames = users
                .map((user) => {
                    const rawValue = isThirdParty ? user.email || user.name : user.name || user.email;
                    return String(rawValue || '').trim();
                })
                .filter((value) => value.length > 0);
        }
        return (
            <div className="w-full min-w-0">
                <h6 className="text-[#F6F8FB] whitespace-normal break-words">
                    {this.state.visitInfo.visitType === BroadCastSession ? (
                        <span
                            className={`${
                                isCompletedOrNotePending
                                    ? ''
                                    : 'cursor-pointer underline underline-offset-4 text-emerald'
                            }`}
                            onClick={() => {
                                if (!isCompletedOrNotePending) {
                                    this.setState({
                                        studentParticipationModal: true,
                                        participationType: 'team',
                                        hideStatus: true,
                                    });
                                    this.fetchBroadcastStudentDetails(this.state.currentPage, 10);
                                    clearInterval(this.timer);
                                }
                            }}
                        >
                            {this.state.sessionStudents.length}
                        </span>
                    ) : (
                        <>
                            {this.state.showAll
                                ? studentNames.length > 0
                                    ? studentNames.map((name, index) => (
                                          <span key={index} title={name} className="break-all">
                                              {name.length > 25 ? `${name.slice(0, 25)}...` : name}
                                              {index !== studentNames.length - 1
                                                  ? RESPONSE_CONSTANT.COMMA
                                                  : RESPONSE_CONSTANT.EMPTY}
                                          </span>
                                      ))
                                    : RESPONSE_CONSTANT.HYPHEN
                                : studentNames.length > 0
                                  ? studentNames.map((name, index) => (
                                        <span key={index} title={name} className="break-all">
                                            {index < 10
                                                ? name.length > 25
                                                    ? `${name.slice(0, 25)}...`
                                                    : name
                                                : null}
                                            {index !== 9 && index < 10
                                                ? RESPONSE_CONSTANT.COMMA
                                                : RESPONSE_CONSTANT.EMPTY}
                                        </span>
                                    ))
                                  : RESPONSE_CONSTANT.HYPHEN}
                            {studentNames.length > 10 ? (
                                <button
                                    className="ml-4 font-medium text-emerald"
                                    onClick={() => this.setState({ showAll: !this.state.showAll })}
                                >
                                    {this.state.showAll
                                        ? this.props.t('showLess')
                                        : this.props.t('showAll')}
                                </button>
                            ) : null}

                            {/* {this.state.sessionStatus !== 'Cancelled' &&
                                // this.state.visitInfo.visitType !== 'CONFERENCE_CALL' &&
                                this.state.visitInfo?.allowAddImage &&
                                this.state.visitInfo?.createdBy === store.get('userSession').id &&
                                (!isThirdParty || isConferenceSession) && (
                                    <button
                                        onClick={() => {
                                            if (isThirdParty) {
                                                this.openAddExternalEmailModal();
                                            } else {
                                                this.openAddRemoveStudentModal();
                                                this.getAvailableStudentList(
                                                    this.props.match.params.visitId
                                                );
                                            }
                                        }}
                                    >
                                        {this.state.visitInfo.visitType !== BroadCastSession && (
                                            <i className="ml-4 fa-solid fa-pen text-UIprimary"></i>
                                        )}
                                    </button>
                                )} */}
                        </>
                    )}
                    {isCompletedOrNotePending && studentNames.length > 0 ? (
                        <button
                            className="ml-4 font-medium text-UIprimary"
                            onClick={() => {
                                this.setState({
                                    studentParticipationModal: true,
                                    participationType: isThirdParty ? 'guest' : 'team',
                                });
                                this.fetchStudentAttendance(
                                    this.state.searchValue,
                                    this.state.currentPage,
                                    1000
                                );
                                clearInterval(this.timer);
                            }}
                        >
                            <i className="mr-2 far fa-user-friends"></i>
                            {isThirdParty
                                ? this.props.t('guestMemberParticipation')
                                : this.props.t('teamMemberParticipation')}
                        </button>
                    ) : null}
                </h6>
            </div>
        );
    }

    // Open Add or Remove Student Modal
    openAddRemoveStudentModal = () => {
        this.setState({ addRemoveStudentModal: true });
        clearInterval(this.timer);
    };

    openAddExternalEmailModal = () => {
        if (this.state.visitInfo.sessionType !== ConferenceCall) {
            return;
        }

        this.setState((prevState) => ({
            addExternalEmailModal: true,
            externalEmails: prevState.savedExternalEmails,
            currentExternalEmail: '',
        }));
        clearInterval(this.timer);
    };

    // Refresh Session Notes (Bud Summary)
    refreshSessionNotes = () => {
        const visitId = this.props.match.params.visitId || this.state.sessionId;
        if (!visitId) return;
        this.setState({ refreshingNotes: true });
        this.props.getBudSummary(visitId, (response) => {
            if (response && response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                this.props.getVisitInformation(visitId, (visitResponse) => {
                    this.setState({ refreshingNotes: false });
                    if (visitResponse.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.setState({
                            visitInfo: visitResponse.response,
                            subjective: this.normalizeNoteText(
                                visitResponse.response.soapNote?.subjective
                            ),
                            objective: this.normalizeNoteText(
                                visitResponse.response.soapNote?.objective
                            ),
                            plan: this.normalizeNoteText(visitResponse.response.soapNote?.plan),
                            materialImages: visitResponse.response.soapNote?.materialImages,
                        });
                    }
                });
            } else {
                this.setState({ refreshingNotes: false });
                this.props.showNotification(
                    response?.message || 'Failed to refresh notes',
                    RESPONSE_CONSTANT.WARNING
                );
            }
        });
    };

    getExternalInviteLink = () => {
        const externalInviteLink = [
            this.state.visitInfo?.externalInviteLink,
            this.props.visitDetails?.externalInviteLink,
        ].find((link) => typeof link === 'string' && link.trim());

        return externalInviteLink ? externalInviteLink.trim() : '';
    };

    shouldShowExternalInviteLink = () => {
        const sessionTypes = [
            this.state.visitInfo?.sessionType,
            this.state.visitInfo?.visitType,
            this.props.visitDetails?.sessionType,
            this.props.visitDetails?.visitType,
        ].map((type) => (typeof type === 'string' ? type.trim() : type));
        const hiddenSessionStatuses = [
            'Note Pending',
            'Team Member Missed',
            'Owner Missed',
            'Completed',
            'Cancelled',
        ];
        const sessionStatuses = [
            this.state.sessionStatus,
            this.state.visitInfo?.sessionStatus,
            this.props.visitDetails?.sessionStatus,
        ].map((status) => (typeof status === 'string' ? status.trim() : status));

        if (sessionTypes.includes(Scheduled) || sessionTypes.includes(InPerson)) {
            return false;
        }

        if (sessionStatuses.some((status) => hiddenSessionStatuses.includes(status))) {
            return false;
        }

        return (
            this.state.visitInfo.sessionType === ConferenceCall || Boolean(this.getExternalInviteLink())
        );
    };

    copyExternalInviteLink = () => {
        const externalInviteLink = this.getExternalInviteLink();

        if (!externalInviteLink) {
            return;
        }

        const markCopied = () => {
            clearTimeout(this.copyExternalInviteLinkTimer);
            this.setState({ copiedExternalInviteLink: true });
            this.copyExternalInviteLinkTimer = setTimeout(() => {
                this.setState({ copiedExternalInviteLink: false });
            }, 2000);
        };

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(externalInviteLink).then(markCopied).catch(() => {});
            return;
        }

        const textArea = document.createElement('textarea');
        textArea.value = externalInviteLink;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'fixed';
        textArea.style.top = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
            markCopied();
        } catch (error) {
            return;
        } finally {
            document.body.removeChild(textArea);
        }
    };

    // Add Session Notes
    openSessionNotesModal = () => {
        const { sessionNotesModal, sessionNotesTitle, title, sessionNotesEditorMode } =
            this.state;

        return (
            <Modal
                isOpen={sessionNotesModal}
                onRequestClose={() => {
                    this.setState({
                        sessionNotesModal: false,
                        sessionNotesEditorMode: 'raw',
                        subjective: this.state.backupSubjective,
                        objective: this.state.backupObjective,
                        plan: this.state.backupPlan,
                    });
                }}
                className={'modal-width'}
                contentLabel="Example"
                overlayClassName={'modal-background z-index-1'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg bg-card">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 text-lg font-medium text-white">
                                {this.props.t('edit')}{' '}
                                {this.props.language === 'es' ? 'notas' : sessionNotesTitle}
                            </h3>
                            <button
                                type="button"
                                onClick={() => {
                                    this.setState({
                                        sessionNotesModal: false,
                                        sessionNotesEditorMode: 'raw',
                                        subjective: this.state.backupSubjective,
                                        objective: this.state.backupObjective,
                                        plan: this.state.backupPlan,
                                    });
                                }}
                            >
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                        fill="white"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div className="divide-y divide-slate-200">
                            <div className="py-4">
                                {title === 'objective' && (
                                    <div className="flex gap-2 mb-3">
                                        <button
                                            type="button"
                                            className={`px-3 py-1 text-sm rounded ${
                                                sessionNotesEditorMode === 'raw'
                                                    ? 'bg-UIprimary text-white'
                                                    : 'bg-dateselect text-secondary'
                                            }`}
                                            onClick={() =>
                                                this.setState({ sessionNotesEditorMode: 'raw' })
                                            }
                                        >
                                            {this.props.language === 'es'
                                                ? 'Editar contenido'
                                                : 'Edit Content'}
                                        </button>
                                        <button
                                            type="button"
                                            className={`px-3 py-1 text-sm rounded ${
                                                sessionNotesEditorMode === 'formatted'
                                                    ? 'bg-UIprimary text-white'
                                                    : 'bg-dateselect text-secondary'
                                            }`}
                                            onClick={() =>
                                                this.setState({
                                                    sessionNotesEditorMode: 'formatted',
                                                })
                                            }
                                        >
                                            {this.props.language === 'es'
                                                ? 'Vista previa'
                                                : 'Preview Output'}
                                        </button>
                                    </div>
                                )}
                                {title !== 'objective' || sessionNotesEditorMode === 'raw' ? (
                                    <textarea
                                        id="cancellationReason"
                                        name="cancellationReason"
                                        rows={this.state[title]?.length > 200 ? 10 : 4}
                                        onChange={(event) => {
                                            if (title === 'subjective') {
                                                this.setState({ subjective: event.target.value });
                                            } else if (title === 'objective') {
                                                this.setState({ objective: event.target.value });
                                            } else {
                                                this.setState({ plan: event.target.value });
                                            }
                                        }}
                                        value={this.state[title]}
                                        placeholder={
                                            this.props.language === 'es'
                                                ? 'Notas'
                                                : sessionNotesTitle
                                        }
                                        className="block w-full px-2 py-1 font-mono text-white rounded bg-dateselect border-black-10 placeholder:text-secondary sm:text-base leading-6 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    />
                                ) : (
                                    <div className="w-full h-64 p-2 text-white rounded bg-dateselect sm:text-base overflow-auto">
                                        <ReactMarkdown
                                            remarkPlugins={[remarkGfm, remarkBreaks]}
                                            components={{
                                                table: (props) => (
                                                    <div className="w-full overflow-x-auto my-2">
                                                        <table
                                                            className="w-full border-collapse table-fixed text-sm"
                                                            {...props}
                                                        />
                                                    </div>
                                                ),
                                                th: (props) => (
                                                    <th
                                                        className="p-2 text-left border border-gray-500 break-words"
                                                        {...props}
                                                    />
                                                ),
                                                td: (props) => (
                                                    <td
                                                        className="p-2 align-top border border-gray-600 break-words"
                                                        {...props}
                                                    />
                                                ),
                                                p: (props) => (
                                                    <p className="mb-2 leading-5" {...props} />
                                                ),
                                                ul: (props) => (
                                                    <ul
                                                        className="pl-5 mb-2 list-disc"
                                                        {...props}
                                                    />
                                                ),
                                                ol: (props) => (
                                                    <ol
                                                        className="pl-5 mb-2 list-decimal"
                                                        {...props}
                                                    />
                                                ),
                                            }}
                                        >
                                            {this.state.objective || ''}
                                        </ReactMarkdown>
                                    </div>
                                )}
                                {title === 'objective' && (
                                    <p className="mt-2 text-xs text-secondary">
                                        {this.props.language === 'es'
                                            ? 'Use "Editar contenido" para actualizar notas y "Vista previa" para verificar como veran los campos y tablas en la sesion.'
                                            : 'Use Edit Content to update notes and Preview Output to verify how fields and tables will appear in Session Notes.'}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="flex items-center justify-end pt-6 space-x-2">
                            <button
                                data-modal-hide="defaultModal"
                                className="w-3/12 py-2 text-base font-semibold text-white bg-black rounded-lg"
                                onClick={() => {
                                    this.setState({
                                        sessionNotesModal: false,
                                        sessionNotesEditorMode: 'raw',
                                        subjective: this.state.backupSubjective,
                                        objective: this.state.backupObjective,
                                        plan: this.state.backupPlan,
                                    });
                                }}
                            >
                                {this.props.t('cancel')}
                            </button>
                            &nbsp;&nbsp;
                            <button
                                data-modal-hide="defaultModal"
                                className={`w-3/12 py-2 text-base font-semibold text-white rounded-lg ${
                                    this.state.btnLoading ||
                                    (title === 'objective' &&
                                        (!this.state.objective ||
                                            this.state.objective.trim() === ''))
                                        ? 'bg-gray-500 cursor-not-allowed opacity-50'
                                        : 'bg-UIprimary'
                                }`}
                                onClick={() => this.saveSessionNotes(0, true, title)}
                                disabled={
                                    this.state.btnLoading ||
                                    (title === 'objective' &&
                                        (!this.state.objective ||
                                            this.state.objective.trim() === ''))
                                }
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {this.state.btnLoading ? (
                                        <Spinner color="#FFF" />
                                    ) : (
                                        this.props.t('save')
                                    )}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    // Material Image Upload
    handleFileUpload = (event) => {
        const files = event.target.files;
        const MAX_TOTAL_SIZE = 52428800; // 50MB
        const MAX_SINGLE_FILE_SIZE = 10485760; // 10MB
        let { totalUploadedSize = 0, materialUploadedImages = [] } = this.state;
        let newUploadSize = 0;
        const validFiles = [];
        const readerPromises = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (
                (file.type === 'image/png' ||
                    file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'application/pdf') &&
                file.size <= MAX_SINGLE_FILE_SIZE
            ) {
                newUploadSize += file.size;
                if (totalUploadedSize + newUploadSize > MAX_TOTAL_SIZE) {
                    this.setState({ isImageUploaded: false });
                    this.props.showNotification(
                        RESPONSE_CONSTANT.MEDIA_TOTAL_SIZE_EXCEEDED,
                        RESPONSE_CONSTANT.WARNING
                    );
                    return;
                }
                validFiles.push({ file, size: file.size });
            } else if (file.size > MAX_SINGLE_FILE_SIZE) {
                this.setState({ isImageUploaded: false });
                this.props.showNotification(
                    RESPONSE_CONSTANT.MEDIA_FILE_SIZE,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            } else {
                this.setState({ isImageUploaded: false });
                this.props.showNotification(
                    RESPONSE_CONSTANT.UPLOAD_ONLY_IMAGE,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
        }

        this.setState({ isImageUploaded: true });

        validFiles.forEach(({ file }) => {
            const reader = new FileReader();
            readerPromises.push(
                new Promise((resolve) => {
                    reader.onloadend = () => resolve({ result: reader.result, size: file.size });
                    reader.readAsDataURL(file);
                })
            );
        });

        Promise.all(readerPromises).then((base64Results) => {
            const newTotalSize = totalUploadedSize + newUploadSize;
            this.setState(
                {
                    materialUploadedImages: [
                        ...materialUploadedImages,
                        ...base64Results.map((res) => res.result),
                    ],
                    totalUploadedSize: newTotalSize,
                },
                () => {
                    this.saveSessionNotes(0, false, '');
                }
            );
        });
    };

    // Remove Images
    removeImage = (id) => {
        this.props.removeImageFromSession(id, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                this.invokeVisitInfo(this.props.match.params.visitId, true);
                // this.saveSessionNotes(0);
            } else {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
            }
        });
    };

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    // Upload Images on  session summary
    complaintImages = (event) => {
        this.setState({ addComplaintImage: true });
        const files = event.target.files;
        const readerPromises = [];
        for (let file of files) {
            if (!['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'].includes(file.type)) {
                this.props.showNotification(
                    RESPONSE_CONSTANT.UPLOAD_ONLY_IMAGE,
                    RESPONSE_CONSTANT.WARNING
                );
                this.setState({ addComplaintImage: false });
                return;
            }
            if (file.size >= 5000000) {
                this.props.showNotification(
                    RESPONSE_CONSTANT.MEDIA_FILE_SIZE,
                    RESPONSE_CONSTANT.WARNING
                );
                this.setState({ addComplaintImage: false });
                return;
            }
            const reader = new FileReader();
            readerPromises.push(
                new Promise((resolve) => {
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(file);
                })
            );
        }
        Promise.all(readerPromises).then((base64Results) => {
            this.setState({ uploadComplaintImages: base64Results }, this.updateComplaintImages);
        });
    };

    // attachment api for image update on session summary
    updateComplaintImages = () => {
        this.props.attachmentSave(
            this.props.match.params.visitId,
            this.state.uploadComplaintImages,
            (result) => {
                if (result) {
                    if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.invokeVisitInfo(this.props.match.params.visitId, true);
                        this.props.showNotification(result.message, 'success');
                    } else {
                        this.props.showNotification(result.message, 'error');
                    }
                } else {
                    this.props.showNotification(this.props.t('imageNotSaved'), 'error');
                    return;
                }
                this.setState({ addComplaintImage: false });
            }
        );
    };

    // remove img on session summary
    removeComplaintImages = (id) => {
        this.props.removeImageFromSession(id, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                this.invokeVisitInfo(this.props.match.params.visitId, true);
            } else {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
            }
        });
    };

    /**
     * Render page
     */
    render() {
        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={
                        this.state.summary
                            ? PATH.IM_PHYSICIAN.MY_STUDENTS
                            : PATH.IM_PHYSICIAN.APPOINTMENT
                    }
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow">
                    <Headers
                        {...this.props}
                        title={
                            this.state.summary
                                ? this.props.t('teamMemberSummary')
                                : this.props.t('sessionSummary')
                        }
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                        <div className="items-center justify-between px-4 sm:flex sm:px-8">
                            <h6 className="m-0 text-lg font-semibold text-white">
                                {this.state.summary
                                    ? this.props.t('teamMemberSummary')
                                    : this.props.t('sessionSummary')}
                            </h6>
                            {this.state.summary ? (
                                <div className="gap-4 mt-4 sm:flex sm:mt-0 xl:w-64">
                                    <select
                                        id="countries"
                                        className="w-full bg-gray-50 border border-black-10 bg-white text-secondary font-normal text-base rounded block py-1.5 px-2"
                                        style={{ cursor: 'pointer' }}
                                        value={this.state.sessionId}
                                        onChange={(event) => {
                                            const selectedValue = event.target.value;
                                            this.setState(
                                                { sessionId: selectedValue, isTabName: 'notes' },
                                                () => {
                                                    this.invokeVisitInfo(selectedValue, true);
                                                }
                                            );
                                        }}
                                    >
                                        {this.state.dateTime &&
                                            this.state.dateTime.map((data) => {
                                                const formattedDate = moment(data.date)
                                                    .locale(this.props.language || 'en')
                                                    .format(
                                                        this.props.language === 'es'
                                                            ? 'D [de] MMMM [de] YYYY, h:mm a'
                                                            : 'MMM DD, YYYY hh:mm A'
                                                    );

                                                return (
                                                    <option key={data.id} value={data.id}>
                                                        {formattedDate}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>

                        {this.state.isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className="flex flex-row flex-grow px-4 mt-6 sm:px-8">
                                    <div className="flex flex-col w-full p-6 rounded-lg bg-card border-black-10">
                                        {!this.state.summary && (
                                            <div className="flex items-baseline justify-end mb-6 mobile-session-status">
                                                {this.renderAppointmentStatusButton(
                                                    this.state.sessionStatus
                                                )}
                                            </div>
                                        )}
                                        {this.state.summary && (
                                            <>
                                                <div className="justify-between mb-6 sm:flex gap-x-6">
                                                    <div className="flex items-center mb-5 gap-x-4 sm:mb-0">
                                                        {/* <img
                              className="flex-none rounded-full sm:w-16 sm:h-16 w-9 h-9 bg-gray-50"
                              src={
                                this.state.visitType === ClassroomSession &&
                                this.state.summary
                                  ? this.state.dateTime[0].studentInfo.image
                                    ? this.state.dateTime[0].studentInfo.image
                                    : profileImg
                                  : this.state.visitInfo.tutee?.image
                                  ? this.state.visitInfo.tutee?.image
                                  : profileImg
                              }
                              alt=""
                            /> */}
                                                        <div>
                                                            <p className="text-base font-semibold">
                                                                {this.state.visitType ===
                                                                    ClassroomSession &&
                                                                this.state.summary
                                                                    ? this.state.dateTime[0]
                                                                          .studentInfo.name
                                                                    : this.state.visitInfo.tutee
                                                                          ?.name}
                                                            </p>
                                                            <p className="text-base truncate text-secondary summary-email">
                                                                {this.state.visitType ===
                                                                    ClassroomSession &&
                                                                this.state.summary
                                                                    ? this.state.dateTime[0]
                                                                          .studentInfo.email
                                                                    : this.state.visitInfo.tutee
                                                                          ?.email}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-col justify-center sm:items-end">
                                                        {this.renderAppointmentStatusButton(
                                                            this.state.sessionStatus
                                                        )}
                                                    </div>
                                                </div>
                                                <hr className="mb-6 border-black-10" />
                                            </>
                                        )}
                                        <div className="w-full">
                                            <div className="items-center pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('sessionType')}
                                                </h6>
                                                <SessionType
                                                    sessionType={this.state.visitInfo.sessionType}
                                                />
                                                {!this.state.summary && (
                                                    <div className="flex items-baseline justify-end web-session-status">
                                                        {this.renderAppointmentStatusButton(
                                                            this.state.sessionStatus
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            {/* <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <h6 className="font-medium text-white">Level 3 Name</h6>
                        <h6
                          className="text-[#F6F8FB]"
                          title={this.state.visitInfo.schoolName}
                        >
                          {this.state.visitInfo.schoolName &&
                          this.state.visitInfo.schoolName.length > 25
                            ? `${this.state.visitInfo.schoolName.slice(
                                0,
                                25
                              )}...`
                            : this.state.visitInfo.schoolName ??
                              RESPONSE_CONSTANT.HYPHEN}
                        </h6>
                      </div> */}
                                            {!this.state.summary &&
                                                this.state.visitInfo.visitType !== InPerson && (
                                                    <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                        {this.state.visitInfo.isAppointment ||
                                                        this.state.visitInfo.isOnDemand ? (
                                                            <h6 className="font-medium text-white">
                                                                {this.props.t('teamMemberName')}
                                                            </h6>
                                                        ) : this.state.visitInfo.visitType ===
                                                          BroadCastSession ? (
                                                            <h6 className="font-medium text-white">
                                                                {this.props.t(
                                                                    'numberOfTeamMembers'
                                                                )}
                                                            </h6>
                                                        ) : (
                                                            <h6 className="font-medium text-white">
                                                                {this.props.t('teamMembers')}
                                                            </h6>
                                                        )}

                                                        <h6
                                                            className="text-[#F6F8FB] sm:col-span-2"
                                                            title={
                                                                this.state.visitInfo
                                                                    .isAppointment ||
                                                                this.state.visitInfo.isOnDemand
                                                                    ? this.state.patientName ||
                                                                      RESPONSE_CONSTANT.HYPHEN
                                                                    : RESPONSE_CONSTANT.EMPTY
                                                            }
                                                        >
                                                            {this.state.visitInfo.isAppointment ||
                                                            this.state.visitInfo.isOnDemand
                                                                ? this.state.patientName
                                                                    ? this.state.patientName
                                                                          .length > 25
                                                                        ? `${this.state.patientName.slice(0, 25)}...`
                                                                        : this.state.patientName
                                                                    : RESPONSE_CONSTANT.HYPHEN
                                                                : this.state.sessionStudents &&
                                                                    this.state.sessionStudents
                                                                        .length > 0
                                                                  ? this.renderStudentsWithMore(
                                                                        this.state.sessionStudents?.filter(
                                                                            (user) =>
                                                                                !this.isThirdPartyUser(
                                                                                    user
                                                                                )
                                                                        )
                                                                    )
                                                                  : RESPONSE_CONSTANT.HYPHEN}
                                                        </h6>
                                                    </div>
                                                )}
                                            {this.state.visitInfo.sessionType ===
                                                ConferenceCall && (
                                                <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                    <h6 className="font-medium text-white">
                                                        {this.props.t('guestMembers')}
                                                    </h6>
                                                    <h6 className="text-[#F6F8FB] sm:col-span-2 break-words">
                                                        {this.state.sessionStudents &&
                                                        this.state.sessionStudents.length > 0
                                                            ? this.renderStudentsWithMore(
                                                                  this.state.sessionStudents?.filter(
                                                                      (user) =>
                                                                          this.isThirdPartyUser(
                                                                              user
                                                                          )
                                                                  ),
                                                                  true
                                                              )
                                                            : RESPONSE_CONSTANT.HYPHEN}
                                                    </h6>
                                                </div>
                                            )}
                                            {this.shouldShowExternalInviteLink() && (
                                                <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                    <h6 className="font-medium text-white">
                                                        {this.props.t('externalInviteLink')}
                                                    </h6>
                                                    {this.getExternalInviteLink() ? (
                                                        <h6 className="flex items-center min-w-0 gap-2 text-[#F6F8FB] sm:col-span-2">
                                                            <span className="inline-flex items-center min-w-0 gap-2 font-medium text-left truncate text-UIprimary">
                                                                <i className="flex-none fas fa-link"></i>
                                                                <span className="min-w-0 truncate">
                                                                    {this.props.t('inviteLink')}
                                                                </span>
                                                            </span>
                                                            <button
                                                                type="button"
                                                                className={`inline-flex items-center justify-center flex-none w-8 h-8 rounded-lg transition-colors ${
                                                                    this.state
                                                                        .copiedExternalInviteLink
                                                                    ? 'text-success'
                                                                    : 'text-UIprimary hover:text-emerald'
                                                                }`}
                                                                onClick={this.copyExternalInviteLink}
                                                                title={this.props.t(
                                                                    this.state
                                                                        .copiedExternalInviteLink
                                                                        ? 'linkCopied'
                                                                        : 'copyExternalInviteLink'
                                                                )}
                                                                aria-label={this.props.t(
                                                                    this.state
                                                                        .copiedExternalInviteLink
                                                                        ? 'linkCopied'
                                                                        : 'copyExternalInviteLink'
                                                                )}
                                                            >
                                                                <i
                                                                    className={`fas ${
                                                                        this.state
                                                                            .copiedExternalInviteLink
                                                                            ? 'fa-check'
                                                                            : 'fa-copy'
                                                                    }`}
                                                                ></i>
                                                            </button>
                                                        </h6>
                                                    ) : (
                                                        <h6 className="text-[#F6F8FB] sm:col-span-2">
                                                            {RESPONSE_CONSTANT.HYPHEN}
                                                        </h6>
                                                    )}
                                                </div>
                                            )}
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t(
                                                        `${AppConfig.labels.channelName}`
                                                    )}
                                                </h6>
                                                <h6 className="text-[#F6F8FB]">
                                                    {this.state.visitInfo.expertiseCategory
                                                        ? this.state.visitInfo.expertiseCategory
                                                        : RESPONSE_CONSTANT.HYPHEN}
                                                </h6>
                                            </div>
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('element')}
                                                </h6>
                                                <h6 className="text-[#F6F8FB]">
                                                    {' '}
                                                    {this.state.visitInfo.expertise
                                                        ? this.state.visitInfo.expertise
                                                        : RESPONSE_CONSTANT.HYPHEN}
                                                </h6>
                                            </div>
                                            {this.state.summary && (
                                                <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                    <h6 className="font-medium text-white">
                                                        {this.props.t('dateOfBirth')}
                                                    </h6>
                                                    <h6 className="text-[#F6F8FB]">
                                                        {this.state.visitInfo.sessionType ? (
                                                            <>
                                                                {this.state.visitInfo?.tutee
                                                                    ?.dateOfBirth !== null
                                                                    ? moment(
                                                                          this.state.visitInfo.tutee
                                                                              ?.dateOfBirth
                                                                      )
                                                                          .locale(
                                                                              this.props.language ||
                                                                                  'en'
                                                                          )
                                                                          .format('MMM DD, YYYY')
                                                                    : RESPONSE_CONSTANT.HYPHEN}
                                                            </>
                                                        ) : (
                                                            RESPONSE_CONSTANT.HYPHEN
                                                        )}
                                                    </h6>
                                                </div>
                                            )}
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('dateOfSession')}
                                                </h6>
                                                <h6 className="text-[#F6F8FB]">
                                                    {this.state.visitInfo.sessionType ? (
                                                        <>
                                                            {this.state.visitInfo.isOnDemand ||
                                                            this.state.visitInfo.sessionType ===
                                                                ClassroomSession ||
                                                            this.state.visitInfo.visitType ===
                                                                InPerson ||
                                                            this.state.visitInfo.visitType ===
                                                                BroadCastSession ||
                                                            this.state.visitInfo.sessionType ===
                                                                ConferenceCall
                                                                ? this.state.visitInfo.onDemand &&
                                                                  moment(
                                                                      this.state.visitInfo.onDemand
                                                                          .startTime
                                                                  )
                                                                      .locale(
                                                                          this.props.language ||
                                                                              'en'
                                                                      )
                                                                      .format('MMM DD, YYYY')
                                                                : this.state.visitInfo
                                                                      .appointment &&
                                                                  moment(
                                                                      this.state.visitInfo
                                                                          .appointment.startTime
                                                                  )
                                                                      .locale(
                                                                          this.props.language ||
                                                                              'en'
                                                                      )
                                                                      .format('MMM DD, YYYY')}
                                                        </>
                                                    ) : (
                                                        RESPONSE_CONSTANT.HYPHEN
                                                    )}
                                                </h6>
                                            </div>
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="font-medium text-white">
                                                    {this.props.t('timeOfSession')}
                                                </h6>
                                                <h6 className="text-[#F6F8FB]">
                                                    {this.state.visitInfo.sessionType ? (
                                                        <>
                                                            {this.state.visitInfo.isOnDemand ||
                                                            this.state.visitInfo.sessionType ===
                                                                ClassroomSession ||
                                                            this.state.visitInfo.visitType ===
                                                                InPerson ||
                                                            this.state.visitInfo.visitType ===
                                                                BroadCastSession ||
                                                            this.state.visitInfo.sessionType ===
                                                                ConferenceCall
                                                                ? this.state.visitInfo.onDemand &&
                                                                  moment(
                                                                      this.state.visitInfo.onDemand
                                                                          .startTime
                                                                  )
                                                                      .locale(
                                                                          this.props.language ||
                                                                              'en'
                                                                      )
                                                                      .format('hh:mm A')
                                                                : this.state.visitInfo
                                                                      .appointment &&
                                                                  moment(
                                                                      this.state.visitInfo
                                                                          .appointment.startTime
                                                                  )
                                                                      .locale(
                                                                          this.props.language ||
                                                                              'en'
                                                                      )
                                                                      .format('hh:mm A')}
                                                            {` ${this.props.t('to')} `}
                                                            {this.state.visitInfo.isOnDemand ||
                                                            this.state.visitInfo.sessionType ===
                                                                ClassroomSession ||
                                                            this.state.visitInfo.visitType ===
                                                                InPerson ||
                                                            this.state.visitInfo.visitType ===
                                                                BroadCastSession ||
                                                            this.state.visitInfo.sessionType ===
                                                                ConferenceCall
                                                                ? this.state.visitInfo.onDemand &&
                                                                  moment(
                                                                      this.state.visitInfo.onDemand
                                                                          .endTime
                                                                  )
                                                                      .locale(
                                                                          this.props.language ||
                                                                              'en'
                                                                      )
                                                                      .format('hh:mm A')
                                                                : this.state.visitInfo
                                                                      .appointment &&
                                                                  moment(
                                                                      this.state.visitInfo
                                                                          .appointment.endTime
                                                                  )
                                                                      .locale(
                                                                          this.props.language ||
                                                                              'en'
                                                                      )
                                                                      .format('hh:mm A')}
                                                        </>
                                                    ) : (
                                                        RESPONSE_CONSTANT.HYPHEN
                                                    )}
                                                </h6>
                                            </div>
                                            {this.state.visitInfo.sessionType !==
                                                ConferenceCall && (
                                                <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                    <h6 className="font-medium text-white">
                                                        {this.props.t('additionalSummary')}
                                                    </h6>
                                                    <h6 className="break-words text-[#F6F8FB]">
                                                        {this.state.visitInfo.comments
                                                            ? this.state.visitInfo.comments
                                                            : RESPONSE_CONSTANT.HYPHEN}
                                                    </h6>
                                                </div>
                                            )}

                                            {this.state.visitInfo.sessionType !==
                                                ConferenceCall && (
                                                <div
                                                    className={`sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0 ${
                                                        this.state.visitInfo?.recordingUrl &&
                                                        (this.state.sessionStatus ===
                                                            'Note Pending' ||
                                                            this.state.sessionStatus ===
                                                                'Completed')
                                                            ? 'pb-6'
                                                            : ''
                                                    }`}
                                                >
                                                    <h6 className="font-medium text-white">
                                                        {this.props.t('uploadedImagesPDF')}
                                                    </h6>
                                                    <div className="flex flex-row flex-wrap w-auto gap-3 mt-4 bg-transparent rounded-lg sm:mt-0 max-w-fit mw-48">
                                                        {this.state.uploadedImages &&
                                                        this.state.uploadedImages.length ? (
                                                            <>
                                                                {this.state.uploadedImages.map(
                                                                    (res, index) => {
                                                                        return (
                                                                            <div
                                                                                className="relative upload"
                                                                                key={index}
                                                                            >
                                                                                {this.state
                                                                                    .visitInfo
                                                                                    ?.allowAddImage &&
                                                                                    this.state
                                                                                        .visitInfo
                                                                                        ?.createdByRole !==
                                                                                        'Student' &&
                                                                                    this.state
                                                                                        .sessionStatus !==
                                                                                        'Cancelled' && (
                                                                                        <span
                                                                                            className="cursor-pointer fas fa-times-circle text-red"
                                                                                            style={{
                                                                                                position:
                                                                                                    'absolute',
                                                                                                right: '-5px',
                                                                                                top: '-5px',
                                                                                            }}
                                                                                            onClick={() => {
                                                                                                this.removeComplaintImages(
                                                                                                    res.id
                                                                                                );
                                                                                            }}
                                                                                        ></span>
                                                                                    )}
                                                                                {res.fileType ===
                                                                                'pdf' ? (
                                                                                    <div
                                                                                        key={index}
                                                                                    >
                                                                                        <a
                                                                                            href={
                                                                                                res.image
                                                                                            }
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                            onClick={(
                                                                                                e
                                                                                            ) => {
                                                                                                e.preventDefault();
                                                                                                const userId =
                                                                                                    store.get(
                                                                                                        'bloomIfAI_id'
                                                                                                    );
                                                                                                this.props.getUserById(
                                                                                                    userId,
                                                                                                    (
                                                                                                        response
                                                                                                    ) => {
                                                                                                        if (
                                                                                                            response
                                                                                                        ) {
                                                                                                            window.open(
                                                                                                                res.image,
                                                                                                                '_blank'
                                                                                                            );
                                                                                                        } else {
                                                                                                            console.error(
                                                                                                                this.props.t(
                                                                                                                    'failedToFetchUserDetails'
                                                                                                                )
                                                                                                            );
                                                                                                        }
                                                                                                    }
                                                                                                );
                                                                                            }}
                                                                                        >
                                                                                            <i
                                                                                                className="fa-solid fa-file-pdf"
                                                                                                style={{
                                                                                                    color: '#c30909',
                                                                                                    width: '5rem',
                                                                                                    height: '5rem',
                                                                                                    borderRadius:
                                                                                                        '0.25rem',
                                                                                                    fontSize:
                                                                                                        '70px',
                                                                                                    display:
                                                                                                        'flex',
                                                                                                    justifyContent:
                                                                                                        'center',
                                                                                                    alignItems:
                                                                                                        'center',
                                                                                                }}
                                                                                            ></i>
                                                                                        </a>
                                                                                    </div>
                                                                                ) : (
                                                                                    <a
                                                                                        href={
                                                                                            res.image
                                                                                        }
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        onClick={(
                                                                                            e
                                                                                        ) => {
                                                                                            e.preventDefault();
                                                                                            const userId =
                                                                                                store.get(
                                                                                                    'bloomIfAI_id'
                                                                                                );
                                                                                            this.props.getUserById(
                                                                                                userId,
                                                                                                (
                                                                                                    response
                                                                                                ) => {
                                                                                                    if (
                                                                                                        response
                                                                                                    ) {
                                                                                                        window.open(
                                                                                                            res.image,
                                                                                                            '_blank'
                                                                                                        );
                                                                                                    } else {
                                                                                                        console.error(
                                                                                                            'Failed to fetch user details'
                                                                                                        );
                                                                                                    }
                                                                                                }
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            src={
                                                                                                res.image
                                                                                            }
                                                                                            className="w-20 h-20 rounded"
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                            alt=""
                                                                                        />
                                                                                    </a>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                {(!this.state.visitInfo
                                                                    ?.allowAddImage ||
                                                                    this.state.sessionStatus ===
                                                                        'Cancelled') &&
                                                                    (this.state.visitInfo
                                                                        ?.createdByRole !==
                                                                        'Educator' ||
                                                                        this.state.visitInfo
                                                                            ?.createdByRole !==
                                                                            'Admin') && (
                                                                        <div className="flex flex-row w-auto gap-3 mt-3 bg-transparent max-w-fit sm:mt-0 text-[#F6F8FB]">
                                                                            -
                                                                        </div>
                                                                    )}
                                                            </>
                                                        )}
                                                        {this.state.visitInfo?.allowAddImage &&
                                                            this.state.visitInfo?.createdByRole !==
                                                                'Student' &&
                                                            this.state.sessionStatus !==
                                                                'Cancelled' && (
                                                                <div className="flex justify-center w-20 h-20 rounded bg-dateselect border-black-10">
                                                                    <div className="flex text-center">
                                                                        <input
                                                                            type="file"
                                                                            multiple
                                                                            id="file-upload"
                                                                            name="file-upload"
                                                                            className="sr-only"
                                                                            onClick={(e) => {
                                                                                e.target.value =
                                                                                    null;
                                                                            }}
                                                                            disabled={
                                                                                this.state
                                                                                    .addComplaintImage
                                                                            }
                                                                            onChange={
                                                                                this.complaintImages
                                                                            }
                                                                            accept=".png,.jpeg,.jpg,.pdf"
                                                                        />
                                                                        <label
                                                                            htmlFor="file-upload"
                                                                            className={`relative ${
                                                                                this.state
                                                                                    .addComplaintImage
                                                                                    ? ''
                                                                                    : 'cursor-pointer'
                                                                            } flex items-center justify-center`}
                                                                        >
                                                                            <span className="text-white">
                                                                                <div className="w-12 h-12 bg-[#543CC2] rounded-full flex items-center justify-center p-[14px] mx-auto">
                                                                                    <svg
                                                                                        width="20"
                                                                                        height="20"
                                                                                        viewBox="0 0 20 20"
                                                                                        fill="none"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                    >
                                                                                        <path
                                                                                            d="M5 10H15"
                                                                                            stroke="white"
                                                                                            strokeWidth="1.5"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                        <path
                                                                                            d="M10 15V5"
                                                                                            stroke="white"
                                                                                            strokeWidth="1.5"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                    </svg>{' '}
                                                                                </div>{' '}
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            )}
                                            {this.state.visitInfo?.recordingUrl &&
                                                (this.state.sessionStatus === 'Note Pending' ||
                                                    this.state.sessionStatus === 'Completed') && (
                                                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                        <h6 className="font-medium text-white">
                                                            {this.props.t('recordings')}
                                                        </h6>
                                                        <i
                                                            onClick={() => {
                                                                const userId =
                                                                    store.get('bloomIfAI_id');
                                                                this.props.getUserById(
                                                                    userId,
                                                                    (response) => {
                                                                        if (response) {
                                                                            console.log(
                                                                                'User details fetched successfully:',
                                                                                response
                                                                            );
                                                                        } else {
                                                                            console.error(
                                                                                this.props.t(
                                                                                    'failedToFetchUserDetails'
                                                                                )
                                                                            );
                                                                        }
                                                                    }
                                                                );
                                                                this.setState({
                                                                    isVideoOpen: true,
                                                                    videos: this.state.visitInfo
                                                                        ?.recordingUrls,
                                                                });
                                                            }}
                                                            className="cursor-pointer fab fa-youtube fa-lg text-iconcolor"
                                                        ></i>
                                                    </div>
                                                )}
                                            <div
                                                className={`flex justify-end ${
                                                    this.state.visitInfo.sessionType ===
                                                    ConferenceCall
                                                        ? 'pt-24'
                                                        : ''
                                                }`}
                                            >
                                                <p className="text-UInew">
                                                    {this.props.t('createdTime')} :{' '}
                                                    {this.state.visitInfo.sessionType ? (
                                                        <>
                                                            {this.state.visitInfo.isOnDemand ||
                                                            this.state.visitInfo.sessionType ===
                                                                ClassroomSession ||
                                                            this.state.visitInfo.visitType ===
                                                                InPerson ||
                                                            this.state.visitInfo.visitType ===
                                                                BroadCastSession ||
                                                            this.state.visitInfo.sessionType ===
                                                                ConferenceCall
                                                                ? this.state.visitInfo.onDemand &&
                                                                  moment(
                                                                      this.state.visitInfo.onDemand
                                                                          .appointmentDate
                                                                  )
                                                                      .locale(
                                                                          this.props.language ||
                                                                              'en'
                                                                      )
                                                                      .format(
                                                                          this.props.language ===
                                                                              'es'
                                                                              ? 'D [de] MMMM [de] YYYY, h:mm a'
                                                                              : 'MMM DD, YYYY hh:mm A'
                                                                      )
                                                                : this.state.visitInfo
                                                                      .appointment &&
                                                                  moment(
                                                                      this.state.visitInfo
                                                                          .appointment
                                                                          .appointmentDate
                                                                  )
                                                                      .locale(
                                                                          this.props.language ||
                                                                              'en'
                                                                      )
                                                                      .format(
                                                                          this.props.language ===
                                                                              'es'
                                                                              ? 'D [de] MMMM [de] YYYY, h:mm a'
                                                                              : 'MMM DD, YYYY hh:mm A'
                                                                      )}
                                                        </>
                                                    ) : (
                                                        RESPONSE_CONSTANT.HYPHEN
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.sessionStatus === 'Completed' ||
                                this.state.sessionStatus === 'Note Pending' ? (
                                    <div className="flex flex-row flex-grow px-4 mt-6 sm:px-8">
                                        <div className="flex flex-col w-full p-6 rounded-lg bg-card">
                                            <nav className="flex flex-col gap-4 mb-6 sm:flex-row border-b border-[#34373E]">
                                                {this.state.sessionStatus === 'Completed' &&
                                                    this.state.flaggedInformation &&
                                                    this.state.flaggedInformation.sessionId &&
                                                    !this.state.summary && (
                                                        <button
                                                            className={
                                                                this.state.isTabName === 'flagged'
                                                                    ? 'text-primary font-medium text-base px-3 block hover:text-primary focus:outline-none border-b-2 border-primary pb-2'
                                                                    : 'text-secondary text-base font-normal px-3 block focus:outline-none pb-2'
                                                            }
                                                            onClick={() => {
                                                                this.setState({
                                                                    isTabName: 'flagged',
                                                                });
                                                            }}
                                                        >
                                                            {this.props.t('viewFlagInfo')}
                                                        </button>
                                                    )}
                                                <button
                                                    className={
                                                        this.state.isTabName === 'notes'
                                                            ? 'text-UIprimary font-medium text-base px-3 block hover:text-UIprimary focus:outline-none border-b-2 pb-2'
                                                            : 'text-UIsecondary text-base font-normal block focus:outline-none pb-2'
                                                    }
                                                    onClick={() =>
                                                        this.setState({ isTabName: 'notes' })
                                                    }
                                                >
                                                    {this.props.t('viewSessionNotes')}
                                                </button>
                                                {this.state.visitInfo.sessionType !== InPerson && (
                                                    <button
                                                        className={
                                                            this.state.isTabName === 'chat'
                                                                ? 'text-UIprimary font-medium text-base px-3 block hover:text-UIprimary focus:outline-none border-b-2  pb-2'
                                                                : 'text-UIsecondary text-base font-normal px-3 block focus:outline-none pb-2'
                                                        }
                                                        onClick={() => {
                                                            this.setState({
                                                                isTabName: 'chat',
                                                                chatLoading: true,
                                                                chatMessage: [],
                                                                chatLastPage: 1,
                                                                currentChatPage: 1,
                                                            });
                                                            this.getSessionSummaryChatWithPagination(
                                                                this.state.visitInfo.id,
                                                                0,
                                                                this.state.chatPerPage
                                                            );
                                                        }}
                                                    >
                                                        {this.props.t('viewChat')}
                                                    </button>
                                                )}
                                            </nav>

                                            <div id="Tab_session_notes">
                                                {this.state.isTabName === 'notes' ? (
                                                    <div
                                                        className="overflow-x-auto rounded-lg"
                                                        id="notes"
                                                        role="tabpanel"
                                                        aria-labelledby="notes-tab"
                                                    >
                                                        <div className="flex flex-col gap-4 lg:flex-row">
                                                            {/* LEFT SIDE: all your current grids */}
                                                            <div className="flex flex-col w-full p-4 space-y-6 lg:w-1/2">
                                                                <div className="flex flex-col">
                                                                    <div className="order-last mb-6 sm:order-first">
                                                                        <label
                                                                            htmlFor="select-about"
                                                                            className="block mb-2 font-normal text-white"
                                                                        >
                                                                            {this.props.t(
                                                                                `${AppConfig.labels.channelnotes}`
                                                                            )}
                                                                        </label>
                                                                        <div className="flex items-center gap-3">
                                                                            <textarea
                                                                                id="about"
                                                                                name="about"
                                                                                rows="3"
                                                                                maxLength="300"
                                                                                value={
                                                                                    this.props
                                                                                        .visitDetails
                                                                                        ?.soapNote
                                                                                        ?.subjective
                                                                                }
                                                                                disabled={true}
                                                                                placeholder={this.props.t(
                                                                                    'noChannelNotesFound'
                                                                                )}
                                                                                className="block w-full p-2 text-white rounded resize-none bg-dateselect placeholder:text-secondary sm:text-base"
                                                                            />
                                                                            {!this.state.summary &&
                                                                                this.state
                                                                                    .sessionStatus !==
                                                                                    'Completed' &&
                                                                                this.state.visitInfo
                                                                                    ?.tutor
                                                                                    ?.userId ===
                                                                                    store.get(
                                                                                        'userSession'
                                                                                    )?.id && (
                                                                                    <div className="relative flex items-center justify-start order-first sm:order-last">
                                                                                        <button
                                                                                            className={`flex items-center justify-center w-6 h-6 mx-5 rounded-full sm:w-8 sm:h-8 summary-edit-btn ${
                                                                                                this.isMeetingSummaryPending()
                                                                                                    ? 'bg-gray-500 cursor-not-allowed opacity-50'
                                                                                                    : 'bg-UIprimary'
                                                                                            }`}
                                                                                            disabled={this.isMeetingSummaryPending()}
                                                                                            onClick={() => {
                                                                                                this.setState(
                                                                                                    {
                                                                                                        sessionNotesModal: true,
                                                                                                        sessionNotesEditorMode:
                                                                                                            'raw',
                                                                                                        sessionNotesTitle: `${this.props.t(`${AppConfig.labels.channelName}`)} notes`,
                                                                                                        title: 'subjective',
                                                                                                        backupSubjective:
                                                                                                            this
                                                                                                                .state
                                                                                                                .subjective,
                                                                                                        backupObjective:
                                                                                                            this
                                                                                                                .state
                                                                                                                .objective,
                                                                                                        backupPlan:
                                                                                                            this
                                                                                                                .state
                                                                                                                .plan,
                                                                                                    }
                                                                                                );
                                                                                            }}
                                                                                        >
                                                                                            <i
                                                                                                className="text-white fas fa-pen "
                                                                                                style={{
                                                                                                    fontSize:
                                                                                                        '11px',
                                                                                                }}
                                                                                            ></i>
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="flex flex-col">
                                                                    <div className="order-last mb-6 sm:order-first">
                                                                        <label
                                                                            htmlFor="select-about"
                                                                            className="block mb-2 font-normal text-white"
                                                                        >
                                                                            {this.props.t(
                                                                                'sessionNotes'
                                                                            )}
                                                                        </label>
                                                                        <div className="flex items-center gap-3">
                                                                            <div
                                                                                id="about"
                                                                                className="block flex-1 min-w-0 p-2 text-white rounded bg-dateselect sm:text-base h-56 overflow-auto"
                                                                            >
                                                                                {this.state.objective ? (
                                                                                    <ReactMarkdown
                                                                                        remarkPlugins={[
                                                                                            remarkGfm,
                                                                                            remarkBreaks,
                                                                                        ]}
                                                                                        components={{
                                                                                            table: (
                                                                                                props
                                                                                            ) => (
                                                                                                <div className="w-full overflow-x-auto my-2">
                                                                                                    <table
                                                                                                        className="w-full border-collapse table-fixed text-sm"
                                                                                                        {...props}
                                                                                                    />
                                                                                                </div>
                                                                                            ),
                                                                                            th: (
                                                                                                props
                                                                                            ) => (
                                                                                                <th
                                                                                                    className="p-2 text-left border border-gray-500 break-words"
                                                                                                    {...props}
                                                                                                />
                                                                                            ),
                                                                                            td: (
                                                                                                props
                                                                                            ) => (
                                                                                                <td
                                                                                                    className="p-2 align-top border border-gray-600 break-words"
                                                                                                    {...props}
                                                                                                />
                                                                                            ),
                                                                                            p: (
                                                                                                props
                                                                                            ) => (
                                                                                                <p
                                                                                                    className="mb-2 leading-5"
                                                                                                    {...props}
                                                                                                />
                                                                                            ),
                                                                                            ul: (
                                                                                                props
                                                                                            ) => (
                                                                                                <ul
                                                                                                    className="pl-5 mb-2 list-disc"
                                                                                                    {...props}
                                                                                                />
                                                                                            ),
                                                                                            ol: (
                                                                                                props
                                                                                            ) => (
                                                                                                <ol
                                                                                                    className="pl-5 mb-2 list-decimal"
                                                                                                    {...props}
                                                                                                />
                                                                                            ),
                                                                                        }}
                                                                                    >
                                                                                        {this.state.objective}
                                                                                    </ReactMarkdown>
                                                                                ) : (
                                                                                    <p className="text-secondary">
                                                                                        {AppConfig.isHealthCare &&
                                                                                        this
                                                                                            .props
                                                                                            .language ===
                                                                                            'es'
                                                                                            ? 'No se encontraron notas del profesional de la salud'
                                                                                            : this
                                                                                                  .props
                                                                                                  .t(
                                                                                                      'noSessionNotesFound'
                                                                                                  )}
                                                                                    </p>
                                                                                )}
                                                                            </div>
                                                                            {!this.state.summary &&
                                                                                this.state
                                                                                    .sessionStatus !==
                                                                                    'Completed' &&
                                                                                this.state.visitInfo
                                                                                    ?.tutor
                                                                                    ?.userId ===
                                                                                    store.get(
                                                                                        'userSession'
                                                                                    )?.id && (
                                                                                    <div className="relative flex flex-col items-center justify-start order-first gap-2 sm:order-last">
                                                                                        <button
                                                                                            className={`flex items-center justify-center w-6 h-6 mx-5 rounded-full sm:w-8 sm:h-8 summary-edit-btn ${
                                                                                                this.isMeetingSummaryPending()
                                                                                                    ? 'bg-gray-500 cursor-not-allowed opacity-50'
                                                                                                    : 'bg-UIprimary'
                                                                                            }`}
                                                                                            disabled={this.isMeetingSummaryPending()}
                                                                                            onClick={() =>
                                                                                                this.setState(
                                                                                                    {
                                                                                                        sessionNotesModal: true,
                                                                                                        sessionNotesEditorMode:
                                                                                                            'raw',
                                                                                                        sessionNotesTitle:
                                                                                                            this.props.t(
                                                                                                                'sessionNotes'
                                                                                                            ),
                                                                                                        title: 'objective',
                                                                                                        backupSubjective:
                                                                                                            this
                                                                                                                .state
                                                                                                                .subjective,
                                                                                                        backupObjective:
                                                                                                            this
                                                                                                                .state
                                                                                                                .objective,
                                                                                                        backupPlan:
                                                                                                            this
                                                                                                                .state
                                                                                                                .plan,
                                                                                                    }
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <i
                                                                                                className="text-white fas fa-pen "
                                                                                                style={{
                                                                                                    fontSize:
                                                                                                        '11px',
                                                                                                }}
                                                                                            ></i>
                                                                                        </button>
                                                                                        <button
                                                                                            className={`flex items-center justify-center w-6 h-6 mx-5 rounded-full sm:w-8 sm:h-8 ${
                                                                                                this
                                                                                                    .state
                                                                                                    .refreshingNotes ||
                                                                                                !this
                                                                                                    .props
                                                                                                    .visitDetails
                                                                                                    ?.transcriptionFileURL
                                                                                                    ? 'bg-gray-500 cursor-not-allowed opacity-50'
                                                                                                    : 'bg-UIprimary'
                                                                                            }`}
                                                                                            disabled={
                                                                                                this
                                                                                                    .state
                                                                                                    .refreshingNotes ||
                                                                                                !this
                                                                                                    .props
                                                                                                    .visitDetails
                                                                                                    ?.transcriptionFileURL
                                                                                            }
                                                                                            onClick={() =>
                                                                                                this.refreshSessionNotes()
                                                                                            }
                                                                                            title="Refresh Session Notes"
                                                                                        >
                                                                                            <i
                                                                                                className={`text-white fas fa-sync-alt ${this.state.refreshingNotes ? 'fa-spin' : ''}`}
                                                                                                style={{
                                                                                                    fontSize:
                                                                                                        '11px',
                                                                                                }}
                                                                                            ></i>
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="flex flex-col">
                                                                    <div className="order-last mb-6 sm:order-first">
                                                                        <label
                                                                            htmlFor="select-about"
                                                                            className="block mb-2 font-normal text-white"
                                                                        >
                                                                            {this.props.t(
                                                                                'documents'
                                                                            )}{' '}
                                                                        </label>
                                                                        {!(
                                                                            this.state
                                                                                .materialImages &&
                                                                            this.state
                                                                                .materialImages
                                                                                .length
                                                                        ) && (
                                                                            <div
                                                                                className={`mt-2 flex justify-center rounded border-black-10 ${
                                                                                    this.state
                                                                                        .isImageUploaded ||
                                                                                    this.state
                                                                                        .summary
                                                                                        ? 'bg-dateselect'
                                                                                        : 'bg-dateselect'
                                                                                }`}
                                                                            >
                                                                                <div className="mt-6 text-center">
                                                                                    <input
                                                                                        type="file"
                                                                                        multiple
                                                                                        id="file-upload"
                                                                                        name="file-upload"
                                                                                        className="sr-only"
                                                                                        onClick={(
                                                                                            e
                                                                                        ) => {
                                                                                            e.target.value =
                                                                                                null;
                                                                                        }}
                                                                                        disabled={
                                                                                            this
                                                                                                .state
                                                                                                .isImageUploaded ||
                                                                                            this
                                                                                                .state
                                                                                                .summary ||
                                                                                            this.state.sessionStatus?.toLowerCase() ===
                                                                                                'completed' ||
                                                                                            this
                                                                                                .state
                                                                                                .visitInfo
                                                                                                ?.tutor
                                                                                                ?.userId !==
                                                                                                store.get(
                                                                                                    'userSession'
                                                                                                )
                                                                                                    ?.id
                                                                                        }
                                                                                        onChange={
                                                                                            this
                                                                                                .handleFileUpload
                                                                                        }
                                                                                        accept=".png,.jpeg,.jpg,.pdf"
                                                                                    />
                                                                                    <label
                                                                                        htmlFor="file-upload"
                                                                                        className={`relative ${
                                                                                            this
                                                                                                .state
                                                                                                .isImageUploaded ||
                                                                                            this
                                                                                                .state
                                                                                                .summary ||
                                                                                            this.state.sessionStatus?.toLowerCase() ===
                                                                                                'completed' ||
                                                                                            this
                                                                                                .state
                                                                                                .visitInfo
                                                                                                ?.tutor
                                                                                                ?.userId !==
                                                                                                store.get(
                                                                                                    'userSession'
                                                                                                )
                                                                                                    ?.id
                                                                                                ? ''
                                                                                                : 'cursor-pointer'
                                                                                        } flex items-center justify-center p-8`}
                                                                                    >
                                                                                        {this.state
                                                                                            .visitInfo
                                                                                            ?.tutor
                                                                                            ?.userId ===
                                                                                            store.get(
                                                                                                'userSession'
                                                                                            )?.id &&
                                                                                        !this.state
                                                                                            .isImageUploaded &&
                                                                                        !this.state
                                                                                            .summary ? (
                                                                                            <span className="text-white">
                                                                                                <div className="w-12 h-12 bg-[#543CC2] rounded-full flex items-center justify-center p-[14px] mx-auto">
                                                                                                    <svg
                                                                                                        width="20"
                                                                                                        height="20"
                                                                                                        viewBox="0 0 20 20"
                                                                                                        fill="none"
                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                    >
                                                                                                        <path
                                                                                                            d="M5 10H15"
                                                                                                            stroke="white"
                                                                                                            strokeWidth="1.5"
                                                                                                            strokeLinecap="round"
                                                                                                            strokeLinejoin="round"
                                                                                                        />
                                                                                                        <path
                                                                                                            d="M10 15V5"
                                                                                                            stroke="white"
                                                                                                            strokeWidth="1.5"
                                                                                                            strokeLinecap="round"
                                                                                                            strokeLinejoin="round"
                                                                                                        />
                                                                                                    </svg>{' '}
                                                                                                </div>
                                                                                                <div className="flex mt-4 text-sm leading-6 text-muted">
                                                                                                    <p className="pl-1 text-sm font-normal text-muted">
                                                                                                        {this.props.t(
                                                                                                            'uploadInstructions10MB'
                                                                                                        )}
                                                                                                    </p>
                                                                                                </div>
                                                                                            </span>
                                                                                        ) : (
                                                                                            <span className="text-[#F6F8FB] text-sm font-normal p-8">
                                                                                                {this.props.t(
                                                                                                    'noDocumentsAvailable'
                                                                                                )}
                                                                                            </span>
                                                                                        )}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {this.state
                                                                            .materialImages &&
                                                                        this.state.materialImages
                                                                            .length ? (
                                                                            <div className="flex flex-row flex-wrap w-auto gap-3 mt-4 bg-transparent rounded-lg max-w-fit min-width-50">
                                                                                {this.state.materialImages.map(
                                                                                    (
                                                                                        res,
                                                                                        index
                                                                                    ) => {
                                                                                        return (
                                                                                            <div
                                                                                                className="relative upload"
                                                                                                key={
                                                                                                    index
                                                                                                }
                                                                                            >
                                                                                                {!this
                                                                                                    .state
                                                                                                    .summary &&
                                                                                                    this.state.sessionStatus?.toLowerCase() !==
                                                                                                        'completed' &&
                                                                                                    this
                                                                                                        .state
                                                                                                        .sessionStatus !==
                                                                                                        'Cancelled' &&
                                                                                                    (this
                                                                                                        .state
                                                                                                        .isVisitNoteComplete ===
                                                                                                        0 ||
                                                                                                        this
                                                                                                            .state
                                                                                                            .isVisitNoteComplete ===
                                                                                                            1) && (
                                                                                                        <span
                                                                                                            className="cursor-pointer fas fa-times-circle text-red"
                                                                                                            style={{
                                                                                                                position:
                                                                                                                    'absolute',
                                                                                                                right: '-5px',
                                                                                                                top: '-5px',
                                                                                                            }}
                                                                                                            onClick={() => {
                                                                                                                this.removeImage(
                                                                                                                    res.id
                                                                                                                );
                                                                                                            }}
                                                                                                        ></span>
                                                                                                    )}
                                                                                                {this
                                                                                                    .state
                                                                                                    .visitInfo
                                                                                                    .soapNote
                                                                                                    .visitNoteCompletedStatus ===
                                                                                                0 ? (
                                                                                                    <div className="rounded upload-img border border-[#34373E]">
                                                                                                        {res.fileType ===
                                                                                                        'pdf' ? (
                                                                                                            <div>
                                                                                                                <i
                                                                                                                    className="fa-solid fa-file-pdf"
                                                                                                                    style={{
                                                                                                                        color: '#c30909',
                                                                                                                        width: '5rem',
                                                                                                                        height: '5rem',
                                                                                                                        borderRadius:
                                                                                                                            '0.5rem',
                                                                                                                        fontSize:
                                                                                                                            '50px',
                                                                                                                        display:
                                                                                                                            'flex',
                                                                                                                        justifyContent:
                                                                                                                            'center',
                                                                                                                        alignItems:
                                                                                                                            'center',
                                                                                                                    }}
                                                                                                                ></i>
                                                                                                            </div>
                                                                                                        ) : (
                                                                                                            <img
                                                                                                                src={
                                                                                                                    res.image
                                                                                                                }
                                                                                                                className="w-20 h-20 rounded"
                                                                                                                key={
                                                                                                                    index
                                                                                                                }
                                                                                                                alt=""
                                                                                                            />
                                                                                                        )}
                                                                                                    </div>
                                                                                                ) : res.fileType ===
                                                                                                  'pdf' ? (
                                                                                                    <div
                                                                                                        key={
                                                                                                            index
                                                                                                        }
                                                                                                    >
                                                                                                        <a
                                                                                                            href={
                                                                                                                res.image
                                                                                                            }
                                                                                                            target="_blank"
                                                                                                            rel="noopener noreferrer"
                                                                                                            onClick={(
                                                                                                                e
                                                                                                            ) => {
                                                                                                                e.preventDefault();
                                                                                                                const userId =
                                                                                                                    store.get(
                                                                                                                        'bloomIfAI_id'
                                                                                                                    );
                                                                                                                this.props.getUserById(
                                                                                                                    userId,
                                                                                                                    (
                                                                                                                        response
                                                                                                                    ) => {
                                                                                                                        if (
                                                                                                                            response
                                                                                                                        ) {
                                                                                                                            window.open(
                                                                                                                                res.image,
                                                                                                                                '_blank'
                                                                                                                            );
                                                                                                                        } else {
                                                                                                                            console.error(
                                                                                                                                this.props.t(
                                                                                                                                    'failedToFetchUserDetails'
                                                                                                                                )
                                                                                                                            );
                                                                                                                        }
                                                                                                                    }
                                                                                                                );
                                                                                                            }}
                                                                                                        >
                                                                                                            <i
                                                                                                                className="fa-solid fa-file-pdf"
                                                                                                                style={{
                                                                                                                    color: '#c30909',
                                                                                                                    width: '5rem',
                                                                                                                    height: '5rem',
                                                                                                                    borderRadius:
                                                                                                                        '0.25rem',
                                                                                                                    fontSize:
                                                                                                                        '70px',
                                                                                                                    display:
                                                                                                                        'flex',
                                                                                                                    justifyContent:
                                                                                                                        'center',
                                                                                                                    alignItems:
                                                                                                                        'center',
                                                                                                                }}
                                                                                                            ></i>
                                                                                                        </a>
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <a
                                                                                                        href={
                                                                                                            res.image
                                                                                                        }
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        onClick={(
                                                                                                            e
                                                                                                        ) => {
                                                                                                            e.preventDefault();
                                                                                                            const userId =
                                                                                                                store.get(
                                                                                                                    'bloomIfAI_id'
                                                                                                                );
                                                                                                            this.props.getUserById(
                                                                                                                userId,
                                                                                                                (
                                                                                                                    response
                                                                                                                ) => {
                                                                                                                    if (
                                                                                                                        response
                                                                                                                    ) {
                                                                                                                        window.open(
                                                                                                                            res.image,
                                                                                                                            '_blank'
                                                                                                                        );
                                                                                                                    } else {
                                                                                                                        console.error(
                                                                                                                            this.props.t(
                                                                                                                                'failedToFetchUserDetails'
                                                                                                                            )
                                                                                                                        );
                                                                                                                    }
                                                                                                                }
                                                                                                            );
                                                                                                        }}
                                                                                                    >
                                                                                                        <img
                                                                                                            src={
                                                                                                                res.image
                                                                                                            }
                                                                                                            className="w-20 h-20 rounded"
                                                                                                            key={
                                                                                                                index
                                                                                                            }
                                                                                                            alt=""
                                                                                                        />
                                                                                                    </a>
                                                                                                )}
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="flex flex-col">
                                                                    <div className="order-last sm:order-first">
                                                                        <label
                                                                            htmlFor="select-about"
                                                                            className="block mb-2 font-normal text-white"
                                                                        >
                                                                            {this.props.t(
                                                                                'recommendations'
                                                                            )}
                                                                        </label>
                                                                        <div className="flex items-center gap-3">
                                                                            <textarea
                                                                                id="about"
                                                                                name="about"
                                                                                rows="3"
                                                                                maxLength="300"
                                                                                value={
                                                                                    this.props
                                                                                        .visitDetails
                                                                                        ?.soapNote
                                                                                        ?.plan
                                                                                }
                                                                                disabled={true}
                                                                                placeholder={this.props.t(
                                                                                    'noRecommendationsFound'
                                                                                )}
                                                                                className="block w-full p-2 text-white rounded resize-none bg-dateselect placeholder:text-secondary sm:text-base"
                                                                            />
                                                                            {!this.state.summary &&
                                                                                this.state
                                                                                    .sessionStatus !==
                                                                                    'Completed' &&
                                                                                this.state.visitInfo
                                                                                    ?.tutor
                                                                                    ?.userId ===
                                                                                    store.get(
                                                                                        'userSession'
                                                                                    )?.id && (
                                                                                    <div className="relative flex items-center justify-start order-first mt-5 sm:order-last">
                                                                                        <button
                                                                                            className={`flex items-center justify-center w-6 h-6 mx-5 rounded-full sm:w-8 sm:h-8 summary-edit-btn ${
                                                                                                this.isMeetingSummaryPending()
                                                                                                    ? 'bg-gray-500 cursor-not-allowed opacity-50'
                                                                                                    : 'bg-UIprimary'
                                                                                            }`}
                                                                                            disabled={this.isMeetingSummaryPending()}
                                                                                            onClick={() =>
                                                                                                this.setState(
                                                                                                    {
                                                                                                        sessionNotesModal: true,
                                                                                                        sessionNotesEditorMode:
                                                                                                            'raw',
                                                                                                        sessionNotesTitle:
                                                                                                            this.props.t(
                                                                                                                'recommendations'
                                                                                                            ),
                                                                                                        title: 'plan',
                                                                                                        backupSubjective:
                                                                                                            this
                                                                                                                .state
                                                                                                                .subjective,
                                                                                                        backupObjective:
                                                                                                            this
                                                                                                                .state
                                                                                                                .objective,
                                                                                                        backupPlan:
                                                                                                            this
                                                                                                                .state
                                                                                                                .plan,
                                                                                                    }
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <i
                                                                                                className="text-white fas fa-pen "
                                                                                                style={{
                                                                                                    fontSize:
                                                                                                        '11px',
                                                                                                }}
                                                                                            ></i>
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="flex flex-col w-full p-4 lg:w-1/2">
                                                                <label className="block mb-2 font-normal text-white">
                                                                    {this.props.t(
                                                                        'transcriptNotes'
                                                                    )}
                                                                </label>
                                                                <textarea
                                                                    rows={20}
                                                                    value={
                                                                        this.state.transcriptText
                                                                    }
                                                                    disabled
                                                                    placeholder={this.props.t(
                                                                        'noTranscriptNotesFound'
                                                                    )}
                                                                    className="block w-full h-full p-2 text-white rounded resize-none bg-dateselect placeholder:text-secondary sm:text-base"
                                                                />
                                                            </div>
                                                        </div>
                                                        {this.state.sessionStatus !== 'Completed' &&
                                                            !this.state.summary &&
                                                            this.state.visitInfo?.tutor?.userId ===
                                                                store.get('userSession')?.id && (
                                                                <div className="flex flex-row justify-end mt-8 space-x-4">
                                                                    <button
                                                                        className={`rounded-lg font-medium text-base px-4 py-1.5 text-white ${
                                                                            this.state.btnLoading ||
                                                                            this.isMeetingSummaryPending()
                                                                                ? 'bg-gray-500 cursor-not-allowed opacity-50'
                                                                                : 'bg-black'
                                                                        }`}
                                                                        onClick={() => {
                                                                            this.saveSessionNotes(
                                                                                0,
                                                                                true,
                                                                                ''
                                                                            );
                                                                        }}
                                                                        disabled={
                                                                            this.state.btnLoading ||
                                                                            this.isMeetingSummaryPending()
                                                                        }
                                                                    >
                                                                        {this.props.t('save')}
                                                                    </button>
                                                                    <button
                                                                        className={`rounded-lg font-medium text-base px-4 py-1.5 text-white ${
                                                                            this.isMeetingSummaryPending()
                                                                                ? 'bg-gray-500 cursor-not-allowed opacity-50'
                                                                                : 'bg-UIprimary'
                                                                        }`}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                notesCompleteModal: true,
                                                                            });
                                                                            clearInterval(
                                                                                this.timer
                                                                            );
                                                                        }}
                                                                        disabled={
                                                                            this.state.btnLoading ||
                                                                            this.isMeetingSummaryPending()
                                                                        }
                                                                    >
                                                                        {this.props.t(
                                                                            'sessionNotesComplete'
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            )}
                                                    </div>
                                                ) : this.state.isTabName === 'chat' ? (
                                                    <div
                                                        className="pr-4 overflow-auto rounded-lg chat-height"
                                                        id="chat"
                                                        role="tabpanel"
                                                        aria-labelledby="chat-tab"
                                                        ref={this.chatContainerRef}
                                                        onScroll={() => this.handleScroll()}
                                                    >
                                                        <>
                                                            {this.state.chatLoading ? (
                                                                <Loader />
                                                            ) : (
                                                                <>
                                                                    {this.state.chatMessage.map(
                                                                        (res, index) => {
                                                                            // console.log(res, 'res');

                                                                            if (
                                                                                res.messageType ===
                                                                                0
                                                                            ) {
                                                                                // 🔹 MY MESSAGE (Right Side)
                                                                                if (res.me) {
                                                                                    return (
                                                                                        <div
                                                                                            className="flex flex-row-reverse pb-6 md:pb-4"
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                        >
                                                                                            <div className="ml-3 msg-profile"></div>

                                                                                            <div className="msg-text">
                                                                                                {/* Optional: show sender name for your own message */}
                                                                                                <div className="text-right">
                                                                                                    <span
                                                                                                        className="mr-2 font-medium text-white"
                                                                                                        title={
                                                                                                            res.senderName ||
                                                                                                            ''
                                                                                                        }
                                                                                                    >
                                                                                                        {res.senderName ||
                                                                                                            ''}
                                                                                                    </span>
                                                                                                </div>

                                                                                                <div className="p-3 mt-2 text-white break-words whitespace-pre-wrap rounded bg-cyan overflow-anywhere">
                                                                                                    {res.message
                                                                                                        .split(
                                                                                                            /\n/
                                                                                                        )
                                                                                                        .map(
                                                                                                            (
                                                                                                                message,
                                                                                                                i
                                                                                                            ) => (
                                                                                                                <div
                                                                                                                    key={
                                                                                                                        i
                                                                                                                    }
                                                                                                                    title={
                                                                                                                        message
                                                                                                                    }
                                                                                                                >
                                                                                                                    {
                                                                                                                        message
                                                                                                                    }
                                                                                                                    <br />
                                                                                                                </div>
                                                                                                            )
                                                                                                        )}
                                                                                                </div>

                                                                                                <div
                                                                                                    className="flex items-end justify-end text-white"
                                                                                                    style={{
                                                                                                        fontSize:
                                                                                                            '10px',
                                                                                                    }}
                                                                                                >
                                                                                                    {moment(
                                                                                                        res.created
                                                                                                    )
                                                                                                        .locale(
                                                                                                            this
                                                                                                                .props
                                                                                                                .language ||
                                                                                                                'en'
                                                                                                        )
                                                                                                        .format(
                                                                                                            'hh:mm A'
                                                                                                        )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                }

                                                                                // 🔹 OTHER USER MESSAGE (Left Side)
                                                                                return (
                                                                                    <div
                                                                                        className="flex pb-6 md:pb-4"
                                                                                        key={index}
                                                                                    >
                                                                                        {/* <img
                                                      className="rounded-full bg-teal border-black-10 w-14 h-14"
                                                      src={
                                                        res.senderImage
                                                          ? res.senderImage
                                                          : profileImg
                                                      }
                                                      alt=""
                                                    /> */}

                                                                                        <div className="msg-text">
                                                                                            {/* Sender Name */}
                                                                                            <div className="text-left">
                                                                                                <span
                                                                                                    className="mr-2 font-medium text-white"
                                                                                                    title={
                                                                                                        res.senderName ||
                                                                                                        ''
                                                                                                    }
                                                                                                >
                                                                                                    {res.senderName
                                                                                                        ? res
                                                                                                              .senderName
                                                                                                              .length >
                                                                                                          25
                                                                                                            ? `${res.senderName.slice(0, 25)}...`
                                                                                                            : res.senderName
                                                                                                        : ''}
                                                                                                </span>
                                                                                            </div>

                                                                                            <div className="p-3 mt-2 text-white break-words whitespace-pre-wrap rounded bg-black/10 overflow-anywhere">
                                                                                                {res.message
                                                                                                    .split(
                                                                                                        /\n/
                                                                                                    )
                                                                                                    .map(
                                                                                                        (
                                                                                                            message,
                                                                                                            i
                                                                                                        ) => (
                                                                                                            <div
                                                                                                                key={
                                                                                                                    i
                                                                                                                }
                                                                                                                title={
                                                                                                                    message
                                                                                                                }
                                                                                                            >
                                                                                                                {
                                                                                                                    message
                                                                                                                }
                                                                                                                <br />
                                                                                                            </div>
                                                                                                        )
                                                                                                    )}
                                                                                            </div>

                                                                                            <div
                                                                                                className="flex items-end justify-end text-white ms-2"
                                                                                                style={{
                                                                                                    fontSize:
                                                                                                        '10px',
                                                                                                }}
                                                                                            >
                                                                                                {moment(
                                                                                                    res.created
                                                                                                )
                                                                                                    .locale(
                                                                                                        this
                                                                                                            .props
                                                                                                            .language ||
                                                                                                            'en'
                                                                                                    )
                                                                                                    .format(
                                                                                                        'hh:mm A'
                                                                                                    )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            }

                                                                            // 🔹 SYSTEM MESSAGE (Join / Leave)
                                                                            if (
                                                                                res.messageType ===
                                                                                2
                                                                            ) {
                                                                                return (
                                                                                    <div
                                                                                        className="flex justify-center"
                                                                                        key={index}
                                                                                    >
                                                                                        <div
                                                                                            className="px-2 py-1 mt-2 mb-2 text-center rounded-lg text-secondary bg-neutral"
                                                                                            style={{
                                                                                                fontSize: 12,
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                res.message
                                                                                            }{' '}
                                                                                            at{' '}
                                                                                            {moment(
                                                                                                res.created
                                                                                            )
                                                                                                .locale(
                                                                                                    this
                                                                                                        .props
                                                                                                        .language ||
                                                                                                        'en'
                                                                                                )
                                                                                                .format(
                                                                                                    'hh:mm A'
                                                                                                )}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            }

                                                                            return null;
                                                                        }
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="pr-4 overflow-auto rounded-lg chat-height"
                                                        id="flagged"
                                                        role="tabpanel"
                                                        aria-labelledby="flag-tab"
                                                    >
                                                        <FlaggedSessionTable
                                                            flaggedInformation={
                                                                this.state.flaggedInformation
                                                            }
                                                            sessionId={
                                                                this.props.match.params.visitId
                                                            }
                                                            isFromEducator={true}
                                                            invokeVisitInfo={(
                                                                sessionId,
                                                                isLoading
                                                            ) => {
                                                                this.invokeVisitInfo(
                                                                    sessionId,
                                                                    isLoading
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </>
                        )}
                    </div>
                </main>
                {this.openSessionNotesModal()}
                <RecordingModal
                    isVideoOpen={this.state.isVideoOpen}
                    videos={this.state.videos}
                    closeModal={() => {
                        this.setState({
                            isVideoOpen: false,
                            videos: [],
                        });
                    }}
                />
                <AddRemoveStudent
                    openModal={this.state.addRemoveStudentModal}
                    closeModal={() => {
                        this.setState({
                            addRemoveStudentModal: false,
                            editSessionStudents: this.state.savedSessionStudents,
                        });
                        this.setIntervalForGetSessionDetails();
                    }}
                    onChange={(event) => {
                        let deletedStudents = [];
                        let availableStudents = this.state.savedAvailableStudentList;
                        if (event) {
                            deletedStudents = this.state.savedSessionStudents.filter(
                                (obj2) => !event.some((obj1) => obj1['value'] === obj2['value'])
                            );
                        } else {
                            deletedStudents = this.state.savedSessionStudents;
                        }
                        if (deletedStudents && deletedStudents.length) {
                            deletedStudents.forEach((element) => {
                                let obj = {
                                    label: element.label,
                                    value: element.value,
                                    owner: element.stuRollNo,
                                };
                                let isExist = this.state.availableStudentList.find(
                                    (e) => e.value === element.value
                                );
                                if (!isExist) {
                                    availableStudents.push(obj);
                                }
                            });
                        }
                        this.setState({
                            editSessionStudents: event ?? [],
                            availableStudentList: availableStudents,
                        });
                    }}
                    options={this.state.availableStudentList}
                    editSessionStudents={this.state.editSessionStudents}
                    saveStudents={() => {
                        this.saveStudents();
                    }}
                    isStudentLoading={this.state.isStudentLoading}
                    isSaveStudent={this.state.isSaveStudent}
                />
                {this.state.visitInfo.sessionType === ConferenceCall && (
                    <AddExternalEmail
                        openModal={this.state.addExternalEmailModal}
                        closeModal={() => {
                            this.setState({
                                addExternalEmailModal: false,
                                externalEmails: this.state.savedExternalEmails,
                                currentExternalEmail: '',
                            });
                            this.setIntervalForGetSessionDetails();
                        }}
                        onInputChange={this.handleExternalEmailInputChange}
                        onAddEmail={this.handleAddExternalEmail}
                        onRemoveEmail={this.handleRemoveExternalEmail}
                        externalEmails={this.state.externalEmails}
                        currentEmail={this.state.currentExternalEmail}
                        saveExternalEmails={this.saveExternalEmails}
                        isSaveExternalEmail={this.state.isSaveExternalEmail}
                        showValidationError={this.showExternalEmailValidationError}
                    />
                )}
                <StudentParticipation
                    openModal={this.state.studentParticipationModal}
                    closeModal={() => {
                        this.setState({
                            studentParticipationModal: false,
                            participationType: 'team',
                            currentPage: 0,
                            searchValue: '',
                        });
                        this.setIntervalForGetSessionDetails();
                    }}
                    studentAttendanceDetails={this.state.studentAttendanceDetails}
                    isLoading={this.state.isStudentListLoading}
                    pageDisplayCount={this.state.totalPages}
                    currentPage={this.state.currentPage}
                    handlePageChange={(e) => {
                        this.handlePageChange(e);
                    }}
                    onChange={(e) => this.handleSearchUser(e)}
                    value={this.state.searchValue}
                    isBroadcastSession={this.state.visitInfo.visitType === BroadCastSession}
                    participationType={this.state.participationType}
                    hideStatus={this.state.hideStatus}
                />
                <NotesCompleteConfirmation
                    openModal={this.state.notesCompleteModal}
                    closeModal={() => {
                        this.setState({ notesCompleteModal: false });
                        this.setIntervalForGetSessionDetails();
                    }}
                    save={(event) => {
                        this.saveSessionNotes(event, true, '');
                    }}
                    btnLoading={this.state.btnLoading}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        visitDetails: state.VisitInformationState.VisitInformation,
        deactivateUserScreen: state.NetworkInState.deactivateUserScreen,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getVisitInformation: (visitId, callBack) => {
            dispatch(getVisitInformation(visitId, callBack));
        },
        getSessionSummaryChatWithPagination: (visitId, values, callBack) => {
            dispatch(getSessionSummaryChatWithPagination(visitId, values, callBack));
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getAvailableStudentList: (values, callBack) => {
            dispatch(getAvailableStudentList(values, callBack));
        },
        createClassRoomSession: (values, callBack) => {
            dispatch(updateClassRoomSession(values, callBack));
        },
        updateVisitThirdParty: (values, callBack) => {
            dispatch(updateVisitThirdParty(values, callBack));
        },
        getStudentInfoDate: (studentId, callback) => {
            dispatch(getStudentInfoDate(studentId, callback));
        },
        getCallStatus: (id, callback) => {
            dispatch(getCallStatus(id, callback));
        },
        removeImageFromSession: (id, callback) => {
            dispatch(removeImageFromSession(id, callback));
        },
        fetchStudentAttendance: (values, callback) => {
            dispatch(fetchStudentAttendance(values, callback));
        },
        fetchBroadcastStudentDetails: (sessionId, values, callback) => {
            dispatch(fetchBroadcastStudentDetails(sessionId, values, callback));
        },
        getUserById: (userId, callBack) => {
            dispatch(getUserById(userId, callBack));
        },
        saveSoap: (
            subjective,
            objective,
            plan,
            materialImages,
            handouts,
            visitId,
            isVisitNoteComplete,
            isActiveCall,
            callback
        ) => {
            dispatch(
                saveSoap(
                    subjective,
                    objective,
                    plan,
                    materialImages,
                    handouts,
                    visitId,
                    isVisitNoteComplete,
                    1,
                    callback
                )
            );
        },
        saveSoap_V2: (
            subjective,
            objective,
            plan,
            materialImages,
            handouts,
            visitId,
            isVisitNoteComplete,
            isActiveCall,
            title,
            callback
        ) => {
            dispatch(
                saveSoap_V2(
                    subjective,
                    objective,
                    plan,
                    materialImages,
                    handouts,
                    visitId,
                    isVisitNoteComplete,
                    1,
                    title,
                    callback
                )
            );
        },
        attachmentSave: (id, photo, callback) => {
            dispatch(attachmentSave(id, photo, callback));
        },
        getBudSummary: (visitId, callback) => {
            dispatch(getBudSummary(visitId, callback));
        },
    };
};

const ConnectedWaitingRoom = withLanguage(
    connect(mapStateToProps, mapDispatchToProps)(WaitingRoom)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedWaitingRoom {...props} />
    </LanguageProvider>
);
